/* eslint-env jquery */

// https://stackoverflow.com/questions/1787322/htmlspecialchars-equivalent-in-javascript
export function escapeHtml (text) {
  text = text.toString(); // jb -- text.replace macht sonst bei Zahlen Probleme.
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
    '\uE000': '<span class="hit_highlight">',
    '\uE001': '</span>'
  };
  return text.replace(/[&<>"'\uE000\uE001]/g, function (m) { return map[m]; });
}

// https://stackoverflow.com/questions/10191941/jquery-unique-on-an-array-of-strings
export function unique (array) {
  return array.filter(function (el, index, arr) {
    return index === arr.indexOf(el);
  });
}

export function nonempty (value, index, arr) {
  return typeof value !== 'undefined' && value !== 'undefined' && value.length > 0;
}

export function getQueryParameters (str) {
  const p = {}; // Obacht: NICHT [], denn dann kann ["sort"] nicht funktionieren, denn sort ist bereits die Sortierfunktion
  const kvs = str.split(/&/); // ";" ist nicht mehr erlaubt: https://stackoverflow.com/questions/3481664/semicolon-as-url-query-separator
  for (let i = 0; i < kvs.length; i++) {
    const kv = kvs[i].split('=');
    if (typeof p[kv[0]] === 'undefined') p[kv[0]] = [];
    if (typeof kv[1] === 'undefined') kv[1] = '';
    p[kv[0]].push(decodeURIComponent(kv[1].replace(/\+/g, ' ')));
  }
  return p;
}

export function getUrlParameters () {
  return getQueryParameters(window.location.href.slice(window.location.href.indexOf('?') + 1));
}

export function quoteSolr (s) { // see lib/Suchindex/Utils.pm, quote_solr()
  return s.replace(/([-+&|!(){}[\]^"~*?:/ \\])/g, '\\$1');
}

export function basename(path) { // https://stackoverflow.com/a/15270931
   return path.split('/').reverse()[0];
}

export function noQuery(path) {
   return path.replace(/[?#](?:.|\n)*/, '');
}

function noUndef (s) { // aus treeq.js
  /* wird vor allem in diesem Zusammenhang benötigt:
     https://www.arthistoricum.net/themen/portale/caricature/zeitschriften
     wo treeq.js für eine /collection/ statt /classification/ verwendet wird.
  */
  if (typeof s !== 'undefined') return s;
  return '';
}

function idEncode (s) { // aus treeq.js
  let R = '';
  // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
  s = noUndef(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  // #TODO ab 2021: .normalize("NFD").replace(/\p{Diacritic}/gu, "")
  for (let i = 0; i < s.length; i++) {
    const c = s.substr(i, 1);
    if (c === '/') { R += 'I'; continue; }
    if (i === 0) {
      if (c.match(/^[A-Za-z]$/)) R += c;
      else R += 'x';
      continue;
    }
    if (c.match(/^[A-Za-z0-9]$/)) {
      R += c;
      continue;
    }
    R += '-';
  }
  return R;
}

// -----------------------------------------------------------------------------

export class GraphQueryClient {
  constructor (p) {
    // RegExp wegen Performance ausgelagert:

    this.form = undefined;
    this.result = undefined;
    this.result_facet = undefined;
    this.buttons2 = undefined;
    this.rows = 50;
    this.hl_a_target = '_blank';
    this.debug = false;

    if (typeof p !== 'undefined') {
      this.form = p.form;
      this.result = p.result;
      this.result_facet = p.result_facet;
    }

    this.prevQuery = undefined;
    this.data = undefined;
    this.filterByFacet = [];
    this.facetParameterStr =
      '&facet=true&facet.mincount=1' +
      '&facet.field=type_s' + // '&facet.field={!ex=type_s}type_s' -- siehe auch graphq.js/getFilterByFacet() -- geht noch nicht - org.apache.solr.search.SyntaxError: Expected identifier at pos 8 str='{!graph !tag=$_tt0 from=$_tt1 v=$_tt2 to=$_tt3 }'
      '&facet.field=meta_name_ss' +
      '&facet.field=meta_periodical_title_s' +
      '&facet.field=meta_subject_ss' +
      '&facet.field=meta_name_aut_firstchar_ss' +
      '&f.meta_name_aut_firstchar_ss.facet.sort=index' +
      '&facet.field=meta_language_ss' +
      '&facet.field=parent_ids' +
      '&facet.field=domain_s' +
      // OOPS ^ und $ sind implizit??
      '&f.parent_ids.facet.matches=' + encodeURIComponent('((/??.*?)??/classification/(?!by_)|/digi\\.ub\\.uni-heidelberg\\.de/collection/sammlung).*') + // (?!...) = negative lookahead: no /classification/by_
      '&facet.range=meta_date_dtrs' +
      '&f.meta_date_dtrs.facet.range.start=0000-01-01T00:00:00Z' +
      '&f.meta_date_dtrs.facet.range.end=2100-01-01T00:00:00Z' +
      '&f.meta_date_dtrs.facet.range.gap=%2B1YEAR' + // +1YEAR
      '&f.meta_date_dtrs.facet.mincount=1'; // no .range ??

    this.extraParameters = '';
    this.template = undefined;
    this.paginationDivTempl = undefined;
    this.groupDivTempl = undefined;

    this.formRequestRunning = false; // https://stackoverflow.com/questions/6064232/disable-jquery-function-after-1-click-to-prevent-multiple-executions

    this.ui_lang = 'ger';
    this.locale = 'de-DE';
    this.collator = new Intl.Collator(this.locale);
    this.facetSortAlphabetical = true;

    this.formOptions = {};
    this.formOptions.resultset_restriction = 'auto,higher,lower,none'.split(',');
    this.formOptions.sort = [
      'sort_title_s asc',
      'sort_name_s asc',
      'sort_shelflocator_s asc',
      'sort_date_dt asc',
      'sort_date_dt desc',
      'meta_online_dt desc',
      'score asc',
      'if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, ' +
        'if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_title_s asc',
      'if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, ' +
        'if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_name_s asc',
      'if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, ' +
        'if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_date_dt asc',
      'if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, ' +
        'if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_date_dt desc'
    ];
    this.formOptions.qfo = [ // qfo = query field option(s)
      '',
      'm',
      'meta_title_txt',
      'meta_name_txt',
      'meta_name_aut_txt',
      'meta_date_txt',
      'meta_subject_txt',
      'meta_classification_txt',
      'meta_shelflocator_txt',
      'meta_physicallocation_txt',
      't'
    ];

    this.formOptions.qfoOrder = [
      '',
      'meta_name_txt',
      'meta_title_txt',
      'meta_subject_txt'
    ];

    // nächste Zeile: konvertiert aus Digi-Präsentation/MetsTypes.pm, zzgl. journal
    this.metsTypesList = [
      { type: 'additional', ger: 'Beilage', eng: 'additional' },
      { type: 'address', ger: 'Anrede', eng: 'address' },
      { type: 'album', ger: 'Album', eng: 'album' },
      { type: 'annotation', ger: 'Annotation', eng: 'annotation' },
      { type: 'article', ger: 'Artikel', eng: 'article', no_title: 1 },
      { type: 'atlas', ger: 'Atlas', eng: 'atlas' },
      { type: 'bachelor_thesis', ger: 'Bachelorarbeit', eng: 'bachelor thesis' },
      { type: 'binding', ger: 'Einband', eng: 'binding' },
      { type: 'bookplate', ger: 'Exlibris', eng: 'bookplate' },
      { type: 'cartulary', ger: 'Kartular', eng: 'cartulary' },
      { type: 'chapter', ger: 'Kapitel', eng: 'chapter', no_title: 1 },
      { type: 'charter', ger: 'Urkunde', eng: 'charter' },
      { type: 'collation', ger: 'Bogensignatur', eng: 'collation' },
      { type: 'colophon', ger: 'Kolophon', eng: 'colophon' },
      { type: 'contained_work', ger: 'Beigefügtes oder enthaltenes Werk', eng: 'contained work' },
      { type: 'contents', ger: 'Inhaltsverzeichnis', eng: 'table of contents' },
      { type: 'corrigenda', ger: 'Errata', eng: 'corrigenda' },
      { type: 'cover', ger: 'Deckel', eng: 'cover' },
      { type: 'cover_back', ger: 'Rückdeckel', eng: 'back cover' },
      { type: 'cover_front', ger: 'Vorderdeckel', eng: 'front cover' },
      { type: 'day', ger: 'Tag', eng: 'day' },
      { type: 'dedication', ger: 'Widmung', eng: 'dedication' },
      { type: 'diploma_thesis', ger: 'Diplomarbeit', eng: 'diploma thesis' },
      { type: 'doctoral_thesis', ger: 'Dissertation', eng: 'doctoral thesis' },
      { type: 'document', ger: 'Dokument', eng: 'document' },
      { type: 'dossier', ger: 'Vorgang', eng: 'dossier' },
      { type: 'edge', ger: 'Schnitt', eng: 'edge' },
      { type: 'endsheet', ger: 'Vorsatz', eng: 'endsheet' },
      { type: 'engraved_titlepage', ger: 'Kupfertitel', eng: 'engraved titlepage' },
      { type: 'entry', ger: 'Eintrag', eng: 'entry' },
      { type: 'fascicle', ger: 'Faszikel', eng: 'fascicle' },
      { type: 'file', ger: 'Akte', eng: 'file' },
      { type: 'folder', ger: 'Mappe', eng: 'folder' },
      { type: 'fragment', ger: 'Fragment', eng: 'fragment' },
      { type: 'front_matter', ger: 'Schmutztitel', eng: 'front matter' },
      { type: 'frontispiece', ger: 'Frontispiz', eng: 'frontispiece' },
      { type: 'ground_plan', ger: 'Grundriss', eng: 'ground plan' },
      { type: 'habilitation_thesis', ger: 'Habilitation', eng: 'habilitation thesis' },
      { type: 'illustration', ger: 'Illustration', eng: 'illustration' },
      { type: 'image', ger: 'Bild', eng: 'image' },
      { type: 'imprint', ger: 'Impressum', eng: 'imprint' },
      { type: 'index', ger: 'Register', eng: 'index' },
      { type: 'initial_decoration', ger: 'Initialschmuck', eng: 'initial decoration' },
      { type: 'intruduction', ger: 'Einleitung', eng: 'introduction' },
      { type: 'inventory', ger: 'Verzeichnis', eng: 'inventory' },
      { type: 'issue', ger: 'Heft', eng: 'issue' },
      { type: 'judgement', ger: 'Urteil', eng: 'judgement' },
      { type: 'land_register', ger: 'Grundbuch', eng: 'land register' },
      { type: 'leaflet', ger: 'Flugblatt', eng: 'leaflet' },
      { type: 'lecture', ger: 'Vorlesung', eng: 'lecture' },
      { type: 'letter', ger: 'Brief', eng: 'letter' },
      { type: 'magister_thesis', ger: 'Magisterarbeit', eng: 'magister thesis' },
      { type: 'manuscript', ger: 'Handschrift', eng: 'manuscript' },
      { type: 'map', ger: 'Karte', eng: 'map' },
      { type: 'master_thesis', ger: 'Masterarbeit', eng: 'master thesis' },
      { type: 'monograph', ger: 'Monographie', eng: 'monograph' }, // was commented out in MetsTypes.pm
      { type: 'month', ger: 'Monat', eng: 'month' },
      { type: 'multivolume_work', ger: 'Mehrbändiges Werk', eng: 'multivolume work', comment: 'GA eines mehrbändigen Werkes, keine Zeitschriften' }, // was commented out in MetsTypes.pm
      { type: 'musical_notation', ger: 'Musiknotation', eng: 'musical notation' },
      { type: 'newspaper', ger: 'Zeitung', eng: 'newspaper' },
      { type: 'note', ger: 'Vermerk', eng: 'note' },
      { type: 'official_notification', ger: 'Bescheid', eng: 'official notification' },
      { type: 'ornament', ger: 'Buchschmuck', eng: 'ornament' },
      { type: 'paper', ger: 'Vortrag', eng: 'paper' },
      { type: 'paste_down', ger: 'Spiegel', eng: 'paste down' },
      { type: 'periodical', ger: 'Periodica', eng: 'periodical', comment: 'GA einer Zeitschrift' },
      { type: 'journal', ger: 'Zeitschrift', eng: 'Journal', comment: 'GA einer Zeitschrift' },
      { type: 'photograph', ger: 'Fotografie', eng: 'photograph' },
      { type: 'plan', ger: 'Plan', eng: 'plan' },
      { type: 'plate', ger: 'Tafel', eng: 'plate' },
      { type: 'poster', ger: 'Plakat', eng: 'poster' },
      { type: 'preface', ger: 'Vorwort', eng: 'preface' },
      { type: 'preprint', ger: 'Vorabdruck', eng: 'preprint' },
      { type: 'printed_archives', ger: 'Druckerzeugnis (Archivale)', eng: 'printed archives' },
      { type: 'printers_mark', ger: 'Druckermarke', eng: 'printers mark' },
      { type: 'privileges', ger: 'Privilegien', eng: 'privileges' },
      { type: 'proceeding', ger: 'Tagungsband', eng: 'proceeding' },
      { type: 'provenance', ger: 'Besitznachweis', eng: 'provenance' },
      { type: 'register', ger: 'Amtsbuch', eng: 'register' },
      { type: 'report', ger: 'Bericht', eng: 'report' },
      { type: 'research_paper', ger: 'Forschungsarbeit', eng: 'research paper' },
      { type: 'scheme', ger: 'Schema', eng: 'scheme' },
      { type: 'seal', ger: 'Siegel', eng: 'seal' },
      { type: 'section', ger: 'Abschnitt', eng: 'section' },
      { type: 'spine', ger: 'Rücken', eng: 'spine' },
      { type: 'stamp', ger: 'Stempel', eng: 'stamp' },
      { type: 'study', ger: 'Studie', eng: 'study' },
      { type: 'table', ger: 'Tabelle', eng: 'table' },
      { type: 'text', ger: 'Text', eng: 'text' },
      { type: 'title_page', ger: 'Titelblatt', eng: 'title page' },
      { type: 'verse', ger: 'Verse', eng: 'verse' },
      { type: 'volume', ger: 'Band', eng: 'volume', comment: 'Band eines mehrbändigen Werkes oder einer Zeitschrift', no_title: 1 }, // was commented out in MetsTypes.pm
      { type: 'year', ger: 'Jahr', eng: 'year' }
    ];

    this.translateWordList = {
      'Cover of': { eng: 'Cover of', ger: 'Cover von' },
      'ff|meta_name_ss': { eng: 'Author, Editor etc.', ger: 'Autor, Hrsg. etc.' },
      'ff|meta_periodical_title_s': { eng: 'Title of journal', ger: 'Zeitschriftentitel' },
      'ff|meta_subject_ss': { eng: 'Subjects', ger: 'Schlagworte' },
      'ff|meta_date_dtrs': { eng: 'Year', ger: 'Jahr' },
      'ff|meta_name_aut_firstchar_ss': { eng: 'First char of authors', ger: 'Anfangsbuchstabe der Autoren' },
      'ff|meta_language_ss': { eng: 'Language', ger: 'Sprache' },
      'ff|parent_ids': { eng: 'Classification', ger: 'Klassifikation' },
      'ff|type_s': { eng: 'Type of element', ger: 'Elementtyp' },
      'ff|domain_s': { eng: 'Pool', ger: 'Pool' },
      hits: { eng: 'Hits', ger: 'Treffer' },
      filter: { eng: 'Filter', ger: 'Filter' },
      'qf|': { eng: 'Full text / Metadata', ger: 'Volltext / Metadaten' },
      'qf|m': { eng: 'Metadata', ger: 'Metadaten' },
      'qf|meta_title_txt': { eng: 'Title', ger: 'Titel' },
      'qf|meta_name_txt': { eng: 'Author, Editor etc.', ger: 'Autor, Hrsg. etc.' },
      'qf|meta_name_aut_txt': { eng: 'Author', ger: 'Autor' },
      'qf|meta_date_txt': { eng: 'Year', ger: 'Jahr' },
      'qf|meta_subject_txt': { eng: 'Subject', ger: 'Schlagwort' },
      'qf|meta_classification_txt': { eng: 'Classification', ger: 'Klassifikation' },
      'qf|meta_shelflocator_txt': { eng: 'Shelfmark', ger: 'Signatur' },
      'qf|meta_physicallocation_txt': { eng: 'Physical location', ger: 'Besitzende Einrichtung' },
      'qf|type_s': { eng: 'Type of element', ger: 'Elementtyp' },
      'qf|t': { eng: 'Full text', ger: 'Volltext' },
      'restrict result': { eng: 'Restrict hits', ger: 'Treffer einschränken' },
      'resultset_restriction|auto': { eng: 'Automatic', ger: 'Automatisch' },
      'resultset_restriction|higher': { eng: 'Higher elements (journals, multivolume work, ...)', ger: 'Höhere Elemente (Zeitschriften, mehrbändige Werke, ...)' },
      'resultset_restriction|lower': { eng: 'Lower elements (chapter, article, ... )', ger: 'Tiefere Elemente (Kapitel, Artikel, ...)' },
      'resultset_restriction|none': { eng: 'All hits', ger: 'Alle Treffer' },
      'sort by': { eng: 'sort by', ger: 'sortieren nach' },
      'sort|sort_title_s asc': { eng: 'Title', ger: 'Titel' },
      'sort|sort_name_s asc': { eng: 'Name', ger: 'Name' },
      'sort|sort_shelflocator_s asc': { eng: 'Shelfmark', ger: 'Signatur' },
      'sort|sort_date_dt asc': { eng: 'Date', ger: 'Erscheinungsjahr' },
      'sort|sort_date_dt desc': { eng: 'Date descending', ger: 'Erscheinungsjahr absteigend' },
      'sort|meta_online_dt desc': { eng: 'Online Date', ger: 'Online Datum' },
      'sort|score asc': { eng: 'Score', ger: 'Relevanz' },
      'sort|if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_title_s asc': { eng: 'pool, title', ger: 'Pool, Titel' },
      'sort|if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_name_s asc': { eng: 'pool, name', ger: 'Pool, Name' },
      'sort|if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_date_dt asc': { eng: 'pool, date', ger: 'Pool, Datum' },
      'sort|if(eq(strdist("journals.ub.uni-heidelberg.de",domain_s,edit),1), 200, if(eq(strdist("digi.ub.uni-heidelberg.de",domain_s,edit),1), 300, 100)) asc,sort_date_dt desc': { eng: 'pool, date descending', ger: 'Pool, Datum absteigend' },
      'more...': { eng: 'more...', ger: 'mehr...' },
      search: { eng: 'Search', ger: 'Suchen' },
      page: { eng: 'Page', ger: 'Seite' },
      select: { eng: 'Select', ger: 'Auswählen' },
      exclude: { eng: 'Exclude', ger: 'Ausschließen' },
      OR: { eng: 'OR', ger: 'ODER' },
      NOT: { eng: 'NOT', ger: 'NICHT' },
      'domain|digi.ub.uni-heidelberg.de': { eng: 'Heidelberg historic literature — digitized', ger: 'Heidelberger historische Bestände — digital' },
      'domain|journals.ub.uni-heidelberg.de': { eng: 'Heidelberg E-Journals (OJS)', ger: 'Heidelberger E-Journals (OJS)' },
      'domain|heiup.uni-heidelberg.de': { eng: 'Heidelberg E-Books (OMP)', ger: 'Heidelberger E-Books (OMP)' },
      'domain|archiv.ub.uni-heidelberg.de': { eng: 'Heidelberg Fulltext Repositories', ger: 'Heidelberger Volltextrepositorien' },
      'domain|heidicon.ub.uni-heidelberg.de': { eng: 'Images and objects (heidICON)', ger: 'Bilder und Objekte (heidICON)' },
      // generated from https://www.loc.gov/standards/iso639-2/php/code_list.php
      'language|aar': { eng: 'Afar', ger: 'Danakil', fre: 'afar' },
      'language|abk': { eng: 'Abkhazian', ger: 'Abchasisch', fre: 'abkhaze' },
      'language|ace': { eng: 'Achinese', ger: 'Aceh', fre: 'aceh' },
      'language|ach': { eng: 'Acoli', ger: 'Acholi', fre: 'acoli' },
      'language|ada': { eng: 'Adangme', ger: 'Adangme', fre: 'adangme' },
      'language|ady': { eng: 'Adyghe', ger: 'Adygisch', fre: 'adyghé' },
      'language|afa': { eng: 'Afro-Asiatic', ger: 'Hamitosemitische Sprachen (Andere)', fre: 'afro-asiatiques' },
      'language|afh': { eng: 'Afrihili', ger: 'Afrihili', fre: 'afrihili' },
      'language|afr': { eng: 'Afrikaans', ger: 'Afrikaans', fre: 'afrikaans' },
      'language|ain': { eng: 'Ainu', ger: 'Ainu', fre: 'aïnou' },
      'language|aka': { eng: 'Akan', ger: 'Akan', fre: 'akan' },
      'language|akk': { eng: 'Akkadian', ger: 'Akkadisch', fre: 'akkadien' },
      'language|alb': { eng: 'Albanian', ger: 'Albanisch', fre: 'albanais' },
      'language|sqi': { eng: 'Albanian', ger: 'Albanisch', fre: 'albanais' },
      'language|ale': { eng: 'Aleut', ger: 'Aleutisch', fre: 'aléoute' },
      'language|alg': { eng: 'Algonquian', ger: 'Algonkin-Sprachen (Andere)', fre: 'algonquines' },
      'language|alt': { eng: 'Southern Altai', ger: 'Altaisch', fre: 'altai du Sud' },
      'language|amh': { eng: 'Amharic', ger: 'Amharisch', fre: 'amharique' },
      'language|ang': { eng: 'English, Old (ca.450-1100)', ger: 'Altenglisch', fre: 'anglo-saxon (ca.450-1100)' },
      'language|anp': { eng: 'Angika', ger: 'Anga', fre: 'angika' },
      'language|apa': { eng: 'Apache', ger: 'Apachen', fre: 'apaches' },
      'language|ara': { eng: 'Arabic', ger: 'Arabisch', fre: 'arabe' },
      'language|arc': { eng: 'Official Aramaic (700-300 BCE)', ger: 'Aramäisch', fre: "araméen d'empire (700-300 BCE)" },
      'language|arg': { eng: 'Aragonese', ger: 'Aragonesisch', fre: 'aragonais' },
      'language|arm': { eng: 'Armenian', ger: 'Armenisch', fre: 'arménien' },
      'language|hye': { eng: 'Armenian', ger: 'Armenisch', fre: 'arménien' },
      'language|arn': { eng: 'Mapuche', ger: 'Arauka', fre: 'mapuce' },
      'language|arp': { eng: 'Arapaho', ger: 'Arapaho', fre: 'arapaho' },
      'language|art': { eng: 'Artificial', ger: 'Kunstsprachen (Andere)', fre: 'artificielles' },
      'language|arw': { eng: 'Arawak', ger: 'Arawak', fre: 'arawak' },
      'language|asm': { eng: 'Assamese', ger: 'Assamesisch', fre: 'assamais' },
      'language|ast': { eng: 'Bable', ger: 'Asturisch', fre: 'bable' },
      'language|ath': { eng: 'Athapascan', ger: 'Athapaskische Sprachen (Andere)', fre: 'athapascanes' },
      'language|aus': { eng: 'Australian', ger: 'Australische Sprachen', fre: 'australiennes' },
      'language|ava': { eng: 'Avaric', ger: 'Awarisch', fre: 'avar' },
      'language|ave': { eng: 'Avestan', ger: 'Avestisch', fre: 'avestique' },
      'language|awa': { eng: 'Awadhi', ger: 'Awadhi', fre: 'awadhi' },
      'language|aym': { eng: 'Aymara', ger: 'Aymará', fre: 'aymara' },
      'language|aze': { eng: 'Azerbaijani', ger: 'Aserbeidschanisch', fre: 'azéri' },
      'language|bad': { eng: 'Banda', ger: 'Banda-Sprachen (Ubangi-Sprachen)', fre: 'banda' },
      'language|bai': { eng: 'Bamileke', ger: 'Bamileke', fre: 'bamiléké' },
      'language|bak': { eng: 'Bashkir', ger: 'Baschkirisch', fre: 'bachkir' },
      'language|bal': { eng: 'Baluchi', ger: 'Belutschisch', fre: 'baloutchi' },
      'language|bam': { eng: 'Bambara', ger: 'Bambara', fre: 'bambara' },
      'language|ban': { eng: 'Balinese', ger: 'Balinesisch', fre: 'balinais' },
      'language|baq': { eng: 'Basque', ger: 'Baskisch', fre: 'basque' },
      'language|eus': { eng: 'Basque', ger: 'Baskisch', fre: 'basque' },
      'language|bas': { eng: 'Basa', ger: 'Basaa', fre: 'basa' },
      'language|bat': { eng: 'Baltic', ger: 'Baltische Sprachen (Andere)', fre: 'baltes' },
      'language|bej': { eng: 'Beja', ger: 'Bedauye', fre: 'bedja' },
      'language|bel': { eng: 'Belarusian', ger: 'Weißrussisch', fre: 'biélorusse' },
      'language|bem': { eng: 'Bemba', ger: 'Bemba', fre: 'bemba' },
      'language|ben': { eng: 'Bengali', ger: 'Bengali', fre: 'bengali' },
      'language|ber': { eng: 'Berber', ger: 'Berbersprachen (Andere)', fre: 'berbères' },
      'language|bho': { eng: 'Bhojpuri', ger: 'Bhojpuri', fre: 'bhojpuri' },
      'language|bih': { eng: 'Bihari', ger: 'Bihari (Andere)', fre: 'langues biharis' },
      'language|bik': { eng: 'Bikol', ger: 'Bikol', fre: 'bikol' },
      'language|bin': { eng: 'Edo', ger: 'Edo', fre: 'edo' },
      'language|bis': { eng: 'Bislama', ger: 'Beach-la-mar', fre: 'bichlamar' },
      'language|bla': { eng: 'Siksika', ger: 'Blackfoot', fre: 'blackfoot' },
      'language|bnt': { eng: 'Bantu', ger: 'Bantusprachen (Andere)', fre: 'bantou' },
      'language|tib': { eng: 'Tibetan', ger: 'Tibetisch', fre: 'tibétain' },
      'language|bod': { eng: 'Tibetan', ger: 'Tibetisch', fre: 'tibétain' },
      'language|bos': { eng: 'Bosnian', ger: 'Bosnisch', fre: 'bosniaque' },
      'language|bra': { eng: 'Braj', ger: 'Braj-Bhakha', fre: 'braj' },
      'language|bre': { eng: 'Breton', ger: 'Bretonisch', fre: 'breton' },
      'language|btk': { eng: 'Batak', ger: 'Batak', fre: 'batak' },
      'language|bua': { eng: 'Buriat', ger: 'Burjatisch', fre: 'bouriate' },
      'language|bug': { eng: 'Buginese', ger: 'Bugi', fre: 'bugi' },
      'language|bul': { eng: 'Bulgarian', ger: 'Bulgarisch', fre: 'bulgare' },
      'language|bur': { eng: 'Burmese', ger: 'Birmanisch', fre: 'birman' },
      'language|mya': { eng: 'Burmese', ger: 'Birmanisch', fre: 'birman' },
      'language|byn': { eng: 'Blin', ger: 'Bilin', fre: 'blin' },
      'language|cad': { eng: 'Caddo', ger: 'Caddo', fre: 'caddo' },
      'language|cai': { eng: 'Central American Indian', ger: 'Indianersprachen, Zentralamerika (Andere)', fre: "amérindiennes de l'Amérique centrale" },
      'language|car': { eng: 'Galibi Carib', ger: 'Karibische Sprachen', fre: 'karib' },
      'language|cat': { eng: 'Catalan', ger: 'Katalanisch', fre: 'catalan' },
      'language|cau': { eng: 'Caucasian', ger: 'Kaukasische Sprachen (Andere)', fre: 'caucasiennes' },
      'language|ceb': { eng: 'Cebuano', ger: 'Cebuano', fre: 'cebuano' },
      'language|cel': { eng: 'Celtic', ger: 'Keltische Sprachen (Andere)', fre: 'celtes' },
      'language|cze': { eng: 'Czech', ger: 'Tschechisch', fre: 'tchèque' },
      'language|ces': { eng: 'Czech', ger: 'Tschechisch', fre: 'tchèque' },
      'language|cha': { eng: 'Chamorro', ger: 'Chamorro', fre: 'chamorro' },
      'language|chb': { eng: 'Chibcha', ger: 'Chibcha', fre: 'chibcha' },
      'language|che': { eng: 'Chechen', ger: 'Tschetschenisch', fre: 'tchétchène' },
      'language|chg': { eng: 'Chagatai', ger: 'Tschagataisch', fre: 'djaghataï' },
      'language|chi': { eng: 'Chinese', ger: 'Chinesisch', fre: 'chinois' },
      'language|zho': { eng: 'Chinese', ger: 'Chinesisch', fre: 'chinois' },
      'language|chk': { eng: 'Chuukese', ger: 'Trukesisch', fre: 'chuuk' },
      'language|chm': { eng: 'Mari', ger: 'Tscheremissisch', fre: 'mari' },
      'language|chn': { eng: 'Chinook jargon', ger: 'Chinook-Jargon', fre: 'chinook, jargon' },
      'language|cho': { eng: 'Choctaw', ger: 'Choctaw', fre: 'choctaw' },
      'language|chp': { eng: 'Chipewyan', ger: 'Chipewyan', fre: 'chipewyan' },
      'language|chr': { eng: 'Cherokee', ger: 'Cherokee', fre: 'cherokee' },
      'language|chu': { eng: 'Old Slavonic', ger: 'Kirchenslawisch', fre: 'vieux slave' },
      'language|chv': { eng: 'Chuvash', ger: 'Tschuwaschisch', fre: 'tchouvache' },
      'language|chy': { eng: 'Cheyenne', ger: 'Cheyenne', fre: 'cheyenne' },
      'language|cmc': { eng: 'Chamic', ger: 'Cham', fre: 'chames' },
      'language|cnr': { eng: 'Montenegrin', ger: 'Montenegrinisch', fre: 'monténégrin' },
      'language|cop': { eng: 'Coptic', ger: 'Koptisch', fre: 'copte' },
      'language|cor': { eng: 'Cornish', ger: 'Kornisch', fre: 'cornique' },
      'language|cos': { eng: 'Corsican', ger: 'Korsisch', fre: 'corse' },
      'language|cpe': { eng: 'Creoles and pidgins, English based', ger: 'Kreolisch-Englisch (Andere)', fre: "créoles et pidgins basés sur l'anglais" },
      'language|cpf': { eng: 'Creoles and pidgins, French-based', ger: 'Kreolisch-Französisch (Andere)', fre: 'créoles et pidgins basés sur le français' },
      'language|cpp': { eng: 'Creoles and pidgins, Portuguese-based', ger: 'Kreolisch-Portugiesisch (Andere)', fre: 'créoles et pidgins basés sur le portugais' },
      'language|cre': { eng: 'Cree', ger: 'Cree', fre: 'cree' },
      'language|crh': { eng: 'Crimean Tatar', ger: 'Krimtatarisch', fre: 'tatar de Crimé' },
      'language|crp': { eng: 'Creoles and pidgins', ger: 'Kreolische Sprachen', fre: 'créoles et pidgins' },
      'language|csb': { eng: 'Kashubian', ger: 'Kaschubisch', fre: 'kachoube' },
      'language|cus': { eng: 'Cushitic', ger: 'Kuschitische Sprachen (Andere)', fre: 'couchitiques' },
      'language|wel': { eng: 'Welsh', ger: 'Kymrisch', fre: 'gallois' },
      'language|cym': { eng: 'Welsh', ger: 'Kymrisch', fre: 'gallois' },
      'language|dak': { eng: 'Dakota', ger: 'Dakota', fre: 'dakota' },
      'language|dan': { eng: 'Danish', ger: 'Dänisch', fre: 'danois' },
      'language|dar': { eng: 'Dargwa', ger: 'Darginisch', fre: 'dargwa' },
      'language|day': { eng: 'Land Dayak', ger: 'Dajakisch', fre: 'dayak' },
      'language|del': { eng: 'Delaware', ger: 'Delaware', fre: 'delaware' },
      'language|den': { eng: 'Slave (Athapascan)', ger: 'Slave', fre: 'esclave (athapascan)' },
      'language|ger': { eng: 'German', ger: 'Deutsch', fre: 'allemand' },
      'language|deu': { eng: 'German', ger: 'Deutsch', fre: 'allemand' },
      'language|dgr': { eng: 'Dogrib', ger: 'Dogrib', fre: 'dogrib' },
      'language|din': { eng: 'Dinka', ger: 'Dinka', fre: 'dinka' },
      'language|div': { eng: 'Divehi', ger: 'Maledivisch', fre: 'maldivien' },
      'language|doi': { eng: 'Dogri', ger: 'Dogri', fre: 'dogri' },
      'language|dra': { eng: 'Dravidian', ger: 'Drawidische Sprachen (Andere)', fre: 'dravidiennes' },
      'language|dsb': { eng: 'Lower Sorbian', ger: 'Niedersorbisch', fre: 'bas-sorabe' },
      'language|dua': { eng: 'Duala', ger: 'Duala', fre: 'douala' },
      'language|dum': { eng: 'Dutch, Middle (ca.1050-1350)', ger: 'Mittelniederländisch', fre: 'néerlandais moyen (ca. 1050-1350)' },
      'language|dut': { eng: 'Dutch', ger: 'Niederländisch', fre: 'flamand' },
      'language|nld': { eng: 'Dutch', ger: 'Niederländisch', fre: 'flamand' },
      'language|dyu': { eng: 'Dyula', ger: 'Dyula', fre: 'dioula' },
      'language|dzo': { eng: 'Dzongkha', ger: 'Dzongkha', fre: 'dzongkha' },
      'language|efi': { eng: 'Efik', ger: 'Efik', fre: 'efik' },
      'language|egy': { eng: 'Egyptian (Ancient)', ger: 'Ägyptisch', fre: 'égyptien' },
      'language|eka': { eng: 'Ekajuk', ger: 'Ekajuk', fre: 'ekajuk' },
      'language|gre': { eng: 'Greek, Modern (1453-)', ger: 'Neugriechisch', fre: 'grec moderne (après 1453)' },
      'language|ell': { eng: 'Greek, Modern (1453-)', ger: 'Neugriechisch', fre: 'grec moderne (après 1453)' },
      'language|elx': { eng: 'Elamite', ger: 'Elamisch', fre: 'élamite' },
      'language|eng': { eng: 'English', ger: 'Englisch', fre: 'anglais' },
      'language|enm': { eng: 'English, Middle (1100-1500)', ger: 'Mittelenglisch', fre: 'anglais moyen (1100-1500)' },
      'language|epo': { eng: 'Esperanto', ger: 'Esperanto', fre: 'espéranto' },
      'language|est': { eng: 'Estonian', ger: 'Estnisch', fre: 'estonien' },
      'language|ewe': { eng: 'Ewe', ger: 'Ewe', fre: 'éwé' },
      'language|ewo': { eng: 'Ewondo', ger: 'Ewondo', fre: 'éwondo' },
      'language|fan': { eng: 'Fang', ger: 'Pangwe', fre: 'fang' },
      'language|fao': { eng: 'Faroese', ger: 'Färöisch', fre: 'féroïen' },
      'language|per': { eng: 'Persian', ger: 'Persisch', fre: 'persan' },
      'language|fas': { eng: 'Persian', ger: 'Persisch', fre: 'persan' },
      'language|fat': { eng: 'Fanti', ger: 'Fante', fre: 'fanti' },
      'language|fij': { eng: 'Fijian', ger: 'Fidschi', fre: 'fidjien' },
      'language|fil': { eng: 'Filipino', ger: 'Pilipino', fre: 'filipino' },
      'language|fin': { eng: 'Finnish', ger: 'Finnisch', fre: 'finnois' },
      'language|fiu': { eng: 'Finno-Ugrian', ger: 'Finnougrische Sprachen (Andere)', fre: 'finno-ougriennes' },
      'language|fon': { eng: 'Fon', ger: 'Fon', fre: 'fon' },
      'language|fre': { eng: 'French', ger: 'Französisch', fre: 'français' },
      'language|fra': { eng: 'French', ger: 'Französisch', fre: 'français' },
      'language|frm': { eng: 'French, Middle (ca.1400-1600)', ger: 'Mittelfranzösisch', fre: 'français moyen (1400-1600)' },
      'language|fro': { eng: 'French, Old (842-ca.1400)', ger: 'Altfranzösisch', fre: 'français ancien (842-ca.1400)' },
      'language|frr': { eng: 'Northern Frisian', ger: 'Nordfriesisch', fre: 'frison septentrional' },
      'language|frs': { eng: 'Eastern Frisian', ger: 'Ostfriesisch', fre: 'frison oriental' },
      'language|fry': { eng: 'Western Frisian', ger: 'Friesisch', fre: 'frison occidental' },
      'language|ful': { eng: 'Fulah', ger: 'Ful', fre: 'peul' },
      'language|fur': { eng: 'Friulian', ger: 'Friulisch', fre: 'frioulan' },
      'language|gaa': { eng: 'Ga', ger: 'Ga', fre: 'ga' },
      'language|gay': { eng: 'Gayo', ger: 'Gayo', fre: 'gayo' },
      'language|gba': { eng: 'Gbaya', ger: 'Gbaya', fre: 'gbaya' },
      'language|gem': { eng: 'Germanic', ger: 'Germanische Sprachen (Andere)', fre: 'germaniques' },
      'language|geo': { eng: 'Georgian', ger: 'Georgisch', fre: 'géorgien' },
      'language|kat': { eng: 'Georgian', ger: 'Georgisch', fre: 'géorgien' },
      'language|gez': { eng: 'Geez', ger: 'Altäthiopisch', fre: 'guèze' },
      'language|gil': { eng: 'Gilbertese', ger: 'Gilbertesisch', fre: 'kiribati' },
      'language|gla': { eng: 'Gaelic', ger: 'Gälisch-Schottisch', fre: 'gaélique' },
      'language|gle': { eng: 'Irish', ger: 'Irisch', fre: 'irlandais' },
      'language|glg': { eng: 'Galician', ger: 'Galicisch', fre: 'galicien' },
      'language|glv': { eng: 'Manx', ger: 'Manx', fre: 'manx' },
      'language|gmh': { eng: 'German, Middle High (ca.1050-1500)', ger: 'Mittelhochdeutsch', fre: 'allemand, moyen haut (ca. 1050-1500)' },
      'language|goh': { eng: 'German, Old High (ca.750-1050)', ger: 'Althochdeutsch', fre: 'allemand, vieux haut (ca. 750-1050)' },
      'language|gon': { eng: 'Gondi', ger: 'Gondi', fre: 'gond' },
      'language|gor': { eng: 'Gorontalo', ger: 'Gorontalesisch', fre: 'gorontalo' },
      'language|got': { eng: 'Gothic', ger: 'Gotisch', fre: 'gothique' },
      'language|grb': { eng: 'Grebo', ger: 'Grebo', fre: 'grebo' },
      'language|grc': { eng: 'Greek, Ancient (to 1453)', ger: 'Griechisch', fre: "grec ancien (jusqu'à 1453)" },
      'language|grn': { eng: 'Guarani', ger: 'Guaraní', fre: 'guarani' },
      'language|gsw': { eng: 'Alsatian', ger: 'Schweizerdeutsch', fre: 'alsacien' },
      'language|guj': { eng: 'Gujarati', ger: 'Gujarati', fre: 'goudjrati' },
      'language|gwi': { eng: "Gwich'in", ger: 'Kutchin', fre: "gwich'in" },
      'language|hai': { eng: 'Haida', ger: 'Haida', fre: 'haida' },
      'language|hat': { eng: 'Haitian', ger: 'Haïtien (Haiti-Kreolisch)', fre: 'haïtien' },
      'language|hau': { eng: 'Hausa', ger: 'Haussa', fre: 'haoussa' },
      'language|haw': { eng: 'Hawaiian', ger: 'Hawaiisch', fre: 'hawaïen' },
      'language|heb': { eng: 'Hebrew', ger: 'Hebräisch', fre: 'hébreu' },
      'language|her': { eng: 'Herero', ger: 'Herero', fre: 'herero' },
      'language|hil': { eng: 'Hiligaynon', ger: 'Hiligaynon', fre: 'hiligaynon' },
      'language|him': { eng: 'Himachali', ger: 'Himachali', fre: 'langues himachalis' },
      'language|hin': { eng: 'Hindi', ger: 'Hindi', fre: 'hindi' },
      'language|hit': { eng: 'Hittite', ger: 'Hethitisch', fre: 'hittite' },
      'language|hmn': { eng: 'Mong', ger: 'Miao', fre: 'hmong' },
      'language|hmo': { eng: 'Hiri Motu', ger: 'Hiri-Motu', fre: 'hiri motu' },
      'language|hrv': { eng: 'Croatian', ger: 'Kroatisch', fre: 'croate' },
      'language|hsb': { eng: 'Upper Sorbian', ger: 'Obersorbisch', fre: 'haut-sorabe' },
      'language|hun': { eng: 'Hungarian', ger: 'Ungarisch', fre: 'hongrois' },
      'language|hup': { eng: 'Hupa', ger: 'Hupa', fre: 'hupa' },
      'language|iba': { eng: 'Iban', ger: 'Iban', fre: 'iban' },
      'language|ibo': { eng: 'Igbo', ger: 'Ibo', fre: 'igbo' },
      'language|ice': { eng: 'Icelandic', ger: 'Isländisch', fre: 'islandais' },
      'language|isl': { eng: 'Icelandic', ger: 'Isländisch', fre: 'islandais' },
      'language|ido': { eng: 'Ido', ger: 'Ido', fre: 'ido' },
      'language|iii': { eng: 'Nuosu', ger: 'Lalo', fre: 'yi de Sichuan' },
      'language|ijo': { eng: 'Ijo', ger: 'Ijo', fre: 'ijo' },
      'language|iku': { eng: 'Inuktitut', ger: 'Inuktitut', fre: 'inuktitut' },
      'language|ile': { eng: 'Occidental', ger: 'Interlingue', fre: 'interlingue' },
      'language|ilo': { eng: 'Iloko', ger: 'Ilokano', fre: 'ilocano' },
      'language|ina': { eng: 'Interlingua (International Auxiliary Language Association)', ger: 'Interlingua', fre: 'interlingua (langue auxiliaire internationale)' },
      'language|inc': { eng: 'Indic', ger: 'Indoarische Sprachen (Andere)', fre: 'indo-aryennes' },
      'language|ind': { eng: 'Indonesian', ger: 'Bahasa Indonesia', fre: 'indonésien' },
      'language|ine': { eng: 'Indo-European', ger: 'Indogermanische Sprachen (Andere)', fre: 'indo-européennes' },
      'language|inh': { eng: 'Ingush', ger: 'Inguschisch', fre: 'ingouche' },
      'language|ipk': { eng: 'Inupiaq', ger: 'Inupik', fre: 'inupiaq' },
      'language|ira': { eng: 'Iranian', ger: 'Iranische Sprachen (Andere)', fre: 'iraniennes' },
      'language|iro': { eng: 'Iroquoian', ger: 'Irokesische Sprachen', fre: 'iroquoises' },
      'language|ita': { eng: 'Italian', ger: 'Italienisch', fre: 'italien' },
      'language|jav': { eng: 'Javanese', ger: 'Javanisch', fre: 'javanais' },
      'language|jbo': { eng: 'Lojban', ger: 'Lojban', fre: 'lojban' },
      'language|jpn': { eng: 'Japanese', ger: 'Japanisch', fre: 'japonais' },
      'language|jpr': { eng: 'Judeo-Persian', ger: 'Jüdisch-Persisch', fre: 'judéo-persan' },
      'language|jrb': { eng: 'Judeo-Arabic', ger: 'Jüdisch-Arabisch', fre: 'judéo-arabe' },
      'language|kaa': { eng: 'Kara-Kalpak', ger: 'Karakalpakisch', fre: 'karakalpak' },
      'language|kab': { eng: 'Kabyle', ger: 'Kabylisch', fre: 'kabyle' },
      'language|kac': { eng: 'Kachin', ger: 'Kachin', fre: 'kachin' },
      'language|kal': { eng: 'Kalaallisut', ger: 'Grönländisch', fre: 'groenlandais' },
      'language|kam': { eng: 'Kamba', ger: 'Kamba', fre: 'kamba' },
      'language|kan': { eng: 'Kannada', ger: 'Kannada', fre: 'kannada' },
      'language|kar': { eng: 'Karen', ger: 'Karenisch', fre: 'karen' },
      'language|kas': { eng: 'Kashmiri', ger: 'Kaschmiri', fre: 'kashmiri' },
      'language|kau': { eng: 'Kanuri', ger: 'Kanuri', fre: 'kanouri' },
      'language|kaw': { eng: 'Kawi', ger: 'Kawi', fre: 'kawi' },
      'language|kaz': { eng: 'Kazakh', ger: 'Kasachisch', fre: 'kazakh' },
      'language|kbd': { eng: 'Kabardian', ger: 'Kabardinisch', fre: 'kabardien' },
      'language|kha': { eng: 'Khasi', ger: 'Khasi', fre: 'khasi' },
      'language|khi': { eng: 'Khoisan', ger: 'Khoisan-Sprachen (Andere)', fre: 'khoïsan' },
      'language|khm': { eng: 'Central Khmer', ger: 'Kambodschanisch', fre: 'khmer central' },
      'language|kho': { eng: 'Sakan', ger: 'Sakisch', fre: 'sakan' },
      'language|kik': { eng: 'Kikuyu', ger: 'Kikuyu', fre: 'kikuyu' },
      'language|kin': { eng: 'Kinyarwanda', ger: 'Rwanda', fre: 'rwanda' },
      'language|kir': { eng: 'Kyrgyz', ger: 'Kirgisisch', fre: 'kirghiz' },
      'language|kmb': { eng: 'Kimbundu', ger: 'Kimbundu', fre: 'kimbundu' },
      'language|kok': { eng: 'Konkani', ger: 'Konkani', fre: 'konkani' },
      'language|kom': { eng: 'Komi', ger: 'Komi', fre: 'kom' },
      'language|kon': { eng: 'Kongo', ger: 'Kongo', fre: 'kongo' },
      'language|kor': { eng: 'Korean', ger: 'Koreanisch', fre: 'coréen' },
      'language|kos': { eng: 'Kosraean', ger: 'Kosraeanisch', fre: 'kosrae' },
      'language|kpe': { eng: 'Kpelle', ger: 'Kpelle', fre: 'kpellé' },
      'language|krc': { eng: 'Karachay-Balkar', ger: 'Karatschaiisch-Balkarisch', fre: 'karatchai balkar' },
      'language|krl': { eng: 'Karelian', ger: 'Karelisch', fre: 'carélien' },
      'language|kro': { eng: 'Kru', ger: 'Kru-Sprachen (Andere)', fre: 'krou' },
      'language|kru': { eng: 'Kurukh', ger: 'Oraon', fre: 'kurukh' },
      'language|kua': { eng: 'Kuanyama', ger: 'Kwanyama', fre: 'kuanyama' },
      'language|kum': { eng: 'Kumyk', ger: 'Kumükisch', fre: 'koumyk' },
      'language|kur': { eng: 'Kurdish', ger: 'Kurdisch', fre: 'kurde' },
      'language|kut': { eng: 'Kutenai', ger: 'Kutenai', fre: 'kutenai' },
      'language|lad': { eng: 'Ladino', ger: 'Judenspanisch', fre: 'judéo-espagnol' },
      'language|lah': { eng: 'Lahnda', ger: 'Lahnda', fre: 'lahnda' },
      'language|lam': { eng: 'Lamba', ger: 'Lamba-Sprache (Bantusprache)', fre: 'lamba' },
      'language|lao': { eng: 'Lao', ger: 'Laotisch', fre: 'lao' },
      'language|lat': { eng: 'Latin', ger: 'Latein', fre: 'latin' },
      'language|lav': { eng: 'Latvian', ger: 'Lettisch', fre: 'letton' },
      'language|lez': { eng: 'Lezghian', ger: 'Lesgisch', fre: 'lezghien' },
      'language|lim': { eng: 'Limburgan', ger: 'Limburgisch', fre: 'limbourgeois' },
      'language|lin': { eng: 'Lingala', ger: 'Lingala', fre: 'lingala' },
      'language|lit': { eng: 'Lithuanian', ger: 'Litauisch', fre: 'lituanien' },
      'language|lol': { eng: 'Mongo', ger: 'Mongo', fre: 'mongo' },
      'language|loz': { eng: 'Lozi', ger: 'Rotse', fre: 'lozi' },
      'language|ltz': { eng: 'Luxembourgish', ger: 'Luxemburgisch', fre: 'luxembourgeois' },
      'language|lua': { eng: 'Luba-Lulua', ger: 'Lulua', fre: 'luba-lulua' },
      'language|lub': { eng: 'Luba-Katanga', ger: 'Luba-Katanga', fre: 'luba-katanga' },
      'language|lug': { eng: 'Ganda', ger: 'Ganda', fre: 'ganda' },
      'language|lui': { eng: 'Luiseno', ger: 'Luiseño', fre: 'luiseno' },
      'language|lun': { eng: 'Lunda', ger: 'Lunda', fre: 'lunda' },
      'language|luo': { eng: 'Luo (Kenya and Tanzania)', ger: 'Luo', fre: 'luo (Kenya et Tanzanie)' },
      'language|lus': { eng: 'Lushai', ger: 'Lushai', fre: 'lushai' },
      'language|mac': { eng: 'Macedonian', ger: 'Makedonisch', fre: 'macédonien' },
      'language|mkd': { eng: 'Macedonian', ger: 'Makedonisch', fre: 'macédonien' },
      'language|mad': { eng: 'Madurese', ger: 'Maduresisch', fre: 'madourais' },
      'language|mag': { eng: 'Magahi', ger: 'Khotta', fre: 'magahi' },
      'language|mah': { eng: 'Marshallese', ger: 'Marschallesisch', fre: 'marshall' },
      'language|mai': { eng: 'Maithili', ger: 'Maithili', fre: 'maithili' },
      'language|mak': { eng: 'Makasar', ger: 'Makassarisch', fre: 'makassar' },
      'language|mal': { eng: 'Malayalam', ger: 'Malayalam', fre: 'malayalam' },
      'language|man': { eng: 'Mandingo', ger: 'Malinke', fre: 'mandingue' },
      'language|mao': { eng: 'Maori', ger: 'Maori', fre: 'maori' },
      'language|mri': { eng: 'Maori', ger: 'Maori', fre: 'maori' },
      'language|map': { eng: 'Austronesian', ger: 'Austronesische Sprachen (Andere)', fre: 'austronésiennes' },
      'language|mar': { eng: 'Marathi', ger: 'Marathi', fre: 'marathe' },
      'language|mas': { eng: 'Masai', ger: 'Massai', fre: 'massaï' },
      'language|may': { eng: 'Malay', ger: 'Malaiisch', fre: 'malais' },
      'language|msa': { eng: 'Malay', ger: 'Malaiisch', fre: 'malais' },
      'language|mdf': { eng: 'Moksha', ger: 'Mokscha', fre: 'moksa' },
      'language|mdr': { eng: 'Mandar', ger: 'Mandaresisch', fre: 'mandar' },
      'language|men': { eng: 'Mende', ger: 'Mende', fre: 'mendé' },
      'language|mga': { eng: 'Irish, Middle (900-1200)', ger: 'Mittelirisch', fre: 'irlandais moyen (900-1200)' },
      'language|mic': { eng: 'Micmac', ger: 'Micmac', fre: 'micmac' },
      'language|min': { eng: 'Minangkabau', ger: 'Minangkabau', fre: 'minangkabau' },
      'language|mis': { eng: 'Uncoded', ger: 'Einzelne andere Sprachen', fre: 'langues non codées' },
      'language|mkh': { eng: 'Mon-Khmer', ger: 'Mon-Khmer-Sprachen (Andere)', fre: 'môn-khmer' },
      'language|mlg': { eng: 'Malagasy', ger: 'Malagassi', fre: 'malgache' },
      'language|mlt': { eng: 'Maltese', ger: 'Maltesisch', fre: 'maltais' },
      'language|mnc': { eng: 'Manchu', ger: 'Mandschurisch', fre: 'mandchou' },
      'language|mni': { eng: 'Manipuri', ger: 'Meithei', fre: 'manipuri' },
      'language|mno': { eng: 'Manobo', ger: 'Manobo', fre: 'manobo' },
      'language|moh': { eng: 'Mohawk', ger: 'Mohawk', fre: 'mohawk' },
      'language|mon': { eng: 'Mongolian', ger: 'Mongolisch', fre: 'mongol' },
      'language|mos': { eng: 'Mossi', ger: 'Mossi', fre: 'moré' },
      'language|mul': { eng: 'Multiple', ger: 'Mehrere Sprachen', fre: 'multilingue' },
      'language|mun': { eng: 'Munda', ger: 'Mundasprachen (Andere)', fre: 'mounda' },
      'language|mus': { eng: 'Creek', ger: 'Muskogisch', fre: 'muskogee' },
      'language|mwl': { eng: 'Mirandese', ger: 'Mirandesisch', fre: 'mirandais' },
      'language|mwr': { eng: 'Marwari', ger: 'Marwari', fre: 'marvari' },
      'language|myn': { eng: 'Mayan', ger: 'Maya', fre: 'maya' },
      'language|myv': { eng: 'Erzya', ger: 'Erza-Mordwinisch', fre: 'erza' },
      'language|nah': { eng: 'Nahuatl', ger: 'Nahuatl', fre: 'nahuatl' },
      'language|nai': { eng: 'North American Indian', ger: 'Indianersprachen, Nordamerika (Andere)', fre: 'nord-amérindiennes' },
      'language|nap': { eng: 'Neapolitan', ger: 'Neapel / Mundart', fre: 'napolitain' },
      'language|nau': { eng: 'Nauru', ger: 'Nauruanisch', fre: 'nauruan' },
      'language|nav': { eng: 'Navajo', ger: 'Navajo', fre: 'navaho' },
      'language|nbl': { eng: 'South Ndebele', ger: 'Ndebele-Sprache (Transvaal)', fre: 'ndébélé du Sud' },
      'language|nde': { eng: 'North Ndebele', ger: 'Ndebele-Sprache (Simbabwe)', fre: 'ndébélé du Nord' },
      'language|ndo': { eng: 'Ndonga', ger: 'Ndonga', fre: 'ndonga' },
      'language|nds': { eng: 'Low Saxon', ger: 'Niederdeutsch', fre: 'bas saxon' },
      'language|nep': { eng: 'Nepali', ger: 'Nepali', fre: 'népalais' },
      'language|new': { eng: 'Newari', ger: 'Newari', fre: 'newari' },
      'language|nia': { eng: 'Nias', ger: 'Nias', fre: 'nias' },
      'language|nic': { eng: 'Niger-Kordofanian', ger: 'Nigerkordofanische Sprachen (Andere)', fre: 'nigéro-kordofaniennes' },
      'language|niu': { eng: 'Niuean', ger: 'Niue', fre: 'niué' },
      'language|nno': { eng: 'Norwegian Nynorsk', ger: 'Nynorsk', fre: 'norvégien nynorsk' },
      'language|nob': { eng: 'Norwegian Bokmål', ger: 'Bokmål', fre: 'norvégien bokmål' },
      'language|nog': { eng: 'Nogai', ger: 'Nogaisch', fre: 'nogaï' },
      'language|non': { eng: 'Norse, Old', ger: 'Altnorwegisch', fre: 'norrois, vieux' },
      'language|nor': { eng: 'Norwegian', ger: 'Norwegisch', fre: 'norvégien' },
      'language|nqo': { eng: "N'Ko", ger: "N'Ko", fre: "n'ko" },
      'language|nso': { eng: 'Pedi', ger: 'Pedi', fre: 'pedi' },
      'language|nub': { eng: 'Nubian', ger: 'Nubische Sprachen', fre: 'nubiennes' },
      'language|nwc': { eng: 'Old Newari', ger: 'Alt-Newari', fre: 'newari classique' },
      'language|nya': { eng: 'Chewa', ger: 'Nyanja', fre: 'chewa' },
      'language|nym': { eng: 'Nyamwezi', ger: 'Nyamwezi', fre: 'nyamwezi' },
      'language|nyn': { eng: 'Nyankole', ger: 'Nkole', fre: 'nyankolé' },
      'language|nyo': { eng: 'Nyoro', ger: 'Nyoro', fre: 'nyoro' },
      'language|nzi': { eng: 'Nzima', ger: 'Nzima', fre: 'nzema' },
      'language|oci': { eng: 'Occitan (post 1500)', ger: 'Okzitanisch', fre: 'occitan (après 1500)' },
      'language|oji': { eng: 'Ojibwa', ger: 'Ojibwa', fre: 'ojibwa' },
      'language|ori': { eng: 'Oriya', ger: 'Oriya', fre: 'oriya' },
      'language|orm': { eng: 'Oromo', ger: 'Galla', fre: 'galla' },
      'language|osa': { eng: 'Osage', ger: 'Osage', fre: 'osage' },
      'language|oss': { eng: 'Ossetic', ger: 'Ossetisch', fre: 'ossète' },
      'language|ota': { eng: 'Turkish, Ottoman (1500-1928)', ger: 'Osmanisch', fre: 'turc ottoman (1500-1928)' },
      'language|oto': { eng: 'Otomian', ger: 'Otomangue', fre: 'otomi' },
      'language|paa': { eng: 'Papuan', ger: 'Papuasprachen (Andere)', fre: 'papoues' },
      'language|pag': { eng: 'Pangasinan', ger: 'Pangasinan', fre: 'pangasinan' },
      'language|pal': { eng: 'Pahlavi', ger: 'Mittelpersisch', fre: 'pahlavi' },
      'language|pam': { eng: 'Pampanga', ger: 'Pampanggan', fre: 'pampangan' },
      'language|pan': { eng: 'Panjabi', ger: 'Pandschabi', fre: 'pendjabi' },
      'language|pap': { eng: 'Papiamento', ger: 'Papiamento', fre: 'papiamento' },
      'language|pau': { eng: 'Palauan', ger: 'Palau', fre: 'palau' },
      'language|peo': { eng: 'Persian, Old (ca.600-400 B.C.)', ger: 'Altpersisch', fre: 'perse, vieux (ca. 600-400 av. J.-C.)' },
      'language|phi': { eng: 'Philippine', ger: 'Philippinisch-Austronesisch (Andere)', fre: 'philippines' },
      'language|phn': { eng: 'Phoenician', ger: 'Phönikisch', fre: 'phénicien' },
      'language|pli': { eng: 'Pali', ger: 'Pali', fre: 'pali' },
      'language|pol': { eng: 'Polish', ger: 'Polnisch', fre: 'polonais' },
      'language|pon': { eng: 'Pohnpeian', ger: 'Ponapeanisch', fre: 'pohnpei' },
      'language|por': { eng: 'Portuguese', ger: 'Portugiesisch', fre: 'portugais' },
      'language|pra': { eng: 'Prakrit', ger: 'Prakrit', fre: 'prâkrit' },
      'language|pro': { eng: 'Occitan, Old (to 1500)', ger: 'Altokzitanisch', fre: "occitan ancien (jusqu'à 1500)" },
      'language|pus': { eng: 'Pushto', ger: 'Paschtu', fre: 'pachto' },
      'language|qaa-qtz': { eng: 'Reserved for local use', ger: 'Reserviert für lokale Verwendung', fre: "réservée à l'usage local" },
      'language|que': { eng: 'Quechua', ger: 'Quechua', fre: 'quechua' },
      'language|raj': { eng: 'Rajasthani', ger: 'Rajasthani', fre: 'rajasthani' },
      'language|rap': { eng: 'Rapanui', ger: 'Osterinsel', fre: 'rapanui' },
      'language|rar': { eng: 'Rarotongan', ger: 'Rarotonganisch', fre: 'rarotonga' },
      'language|roa': { eng: 'Romance', ger: 'Romanische Sprachen (Andere)', fre: 'romanes' },
      'language|roh': { eng: 'Romansh', ger: 'Rätoromanisch', fre: 'romanche' },
      'language|rom': { eng: 'Romany', ger: 'Romani (Sprache)', fre: 'tsigane' },
      'language|rum': { eng: 'Romanian', ger: 'Rumänisch', fre: 'roumain' },
      'language|ron': { eng: 'Romanian', ger: 'Rumänisch', fre: 'roumain' },
      'language|run': { eng: 'Rundi', ger: 'Rundi', fre: 'rundi' },
      'language|rup': { eng: 'Aromanian', ger: 'Aromunisch', fre: 'aroumain' },
      'language|rus': { eng: 'Russian', ger: 'Russisch', fre: 'russe' },
      'language|sad': { eng: 'Sandawe', ger: 'Sandawe', fre: 'sandawe' },
      'language|sag': { eng: 'Sango', ger: 'Sango', fre: 'sango' },
      'language|sah': { eng: 'Yakut', ger: 'Jakutisch', fre: 'iakoute' },
      'language|sai': { eng: 'South American Indian', ger: 'Indianersprachen, Südamerika (Andere)', fre: 'sud-amérindiennes' },
      'language|sal': { eng: 'Salishan', ger: 'Salish', fre: 'salishennes' },
      'language|sam': { eng: 'Samaritan Aramaic', ger: 'Samaritanisch', fre: 'samaritain' },
      'language|san': { eng: 'Sanskrit', ger: 'Sanskrit', fre: 'sanskrit' },
      'language|sas': { eng: 'Sasak', ger: 'Sasak', fre: 'sasak' },
      'language|sat': { eng: 'Santali', ger: 'Santali', fre: 'santal' },
      'language|scn': { eng: 'Sicilian', ger: 'Sizilianisch', fre: 'sicilien' },
      'language|sco': { eng: 'Scots', ger: 'Schottisch', fre: 'écossais' },
      'language|sel': { eng: 'Selkup', ger: 'Selkupisch', fre: 'selkoupe' },
      'language|sem': { eng: 'Semitic', ger: 'Semitische Sprachen (Andere)', fre: 'sémitiques' },
      'language|sga': { eng: 'Irish, Old (to 900)', ger: 'Altirisch', fre: "irlandais ancien (jusqu'à 900)" },
      'language|sgn': { eng: 'Sign Languages', ger: 'Zeichensprachen', fre: 'langues des signes' },
      'language|shn': { eng: 'Shan', ger: 'Schan', fre: 'chan' },
      'language|sid': { eng: 'Sidamo', ger: 'Sidamo', fre: 'sidamo' },
      'language|sin': { eng: 'Sinhala', ger: 'Singhalesisch', fre: 'singhalais' },
      'language|sio': { eng: 'Siouan', ger: 'Sioux-Sprachen (Andere)', fre: 'sioux' },
      'language|sit': { eng: 'Sino-Tibetan', ger: 'Sinotibetische Sprachen (Andere)', fre: 'sino-tibétaines' },
      'language|sla': { eng: 'Slavic', ger: 'Slawische Sprachen (Andere)', fre: 'slaves' },
      'language|slo': { eng: 'Slovak', ger: 'Slowakisch', fre: 'slovaque' },
      'language|slk': { eng: 'Slovak', ger: 'Slowakisch', fre: 'slovaque' },
      'language|slv': { eng: 'Slovenian', ger: 'Slowenisch', fre: 'slovène' },
      'language|sma': { eng: 'Southern Sami', ger: 'Südsaamisch', fre: 'sami du Sud' },
      'language|sme': { eng: 'Northern Sami', ger: 'Nordsaamisch', fre: 'sami du Nord' },
      'language|smi': { eng: 'Sami', ger: 'Saamisch', fre: 'sames' },
      'language|smj': { eng: 'Lule Sami', ger: 'Lulesaamisch', fre: 'sami de Lule' },
      'language|smn': { eng: 'Inari Sami', ger: 'Inarisaamisch', fre: "sami d'Inari" },
      'language|smo': { eng: 'Samoan', ger: 'Samoanisch', fre: 'samoan' },
      'language|sms': { eng: 'Skolt Sami', ger: 'Skoltsaamisch', fre: 'sami skolt' },
      'language|sna': { eng: 'Shona', ger: 'Schona', fre: 'shona' },
      'language|snd': { eng: 'Sindhi', ger: 'Sindhi', fre: 'sindhi' },
      'language|snk': { eng: 'Soninke', ger: 'Soninke', fre: 'soninké' },
      'language|sog': { eng: 'Sogdian', ger: 'Sogdisch', fre: 'sogdien' },
      'language|som': { eng: 'Somali', ger: 'Somali', fre: 'somali' },
      'language|son': { eng: 'Songhai', ger: 'Songhai', fre: 'songhai' },
      'language|sot': { eng: 'Sotho, Southern', ger: 'Süd-Sotho', fre: 'sotho du Sud' },
      'language|spa': { eng: 'Spanish', ger: 'Spanisch', fre: 'espagnol' },
      'language|srd': { eng: 'Sardinian', ger: 'Sardisch', fre: 'sarde' },
      'language|srn': { eng: 'Sranan Tongo', ger: 'Sranantongo', fre: 'sranan tongo' },
      'language|srp': { eng: 'Serbian', ger: 'Serbisch', fre: 'serbe' },
      'language|srr': { eng: 'Serer', ger: 'Serer', fre: 'sérère' },
      'language|ssa': { eng: 'Nilo-Saharan', ger: 'Nilosaharanische Sprachen (Andere)', fre: 'nilo-sahariennes' },
      'language|ssw': { eng: 'Swati', ger: 'Swasi', fre: 'swati' },
      'language|suk': { eng: 'Sukuma', ger: 'Sukuma', fre: 'sukuma' },
      'language|sun': { eng: 'Sundanese', ger: 'Sundanesisch', fre: 'soundanais' },
      'language|sus': { eng: 'Susu', ger: 'Susu', fre: 'soussou' },
      'language|sux': { eng: 'Sumerian', ger: 'Sumerisch', fre: 'sumérien' },
      'language|swa': { eng: 'Swahili', ger: 'Swahili', fre: 'swahili' },
      'language|swe': { eng: 'Swedish', ger: 'Schwedisch', fre: 'suédois' },
      'language|syc': { eng: 'Classical Syriac', ger: 'Syrisch', fre: 'syriaque classique' },
      'language|syr': { eng: 'Syriac', ger: 'Neuostaramäisch', fre: 'syriaque' },
      'language|tah': { eng: 'Tahitian', ger: 'Tahitisch', fre: 'tahitien' },
      'language|tai': { eng: 'Tai', ger: 'Thaisprachen (Andere)', fre: 'tai' },
      'language|tam': { eng: 'Tamil', ger: 'Tamil', fre: 'tamoul' },
      'language|tat': { eng: 'Tatar', ger: 'Tatarisch', fre: 'tatar' },
      'language|tel': { eng: 'Telugu', ger: 'Telugu', fre: 'télougou' },
      'language|tem': { eng: 'Timne', ger: 'Temne', fre: 'temne' },
      'language|ter': { eng: 'Tereno', ger: 'Tereno', fre: 'tereno' },
      'language|tet': { eng: 'Tetum', ger: 'Tetum', fre: 'tetum' },
      'language|tgk': { eng: 'Tajik', ger: 'Tadschikisch', fre: 'tadjik' },
      'language|tgl': { eng: 'Tagalog', ger: 'Tagalog', fre: 'tagalog' },
      'language|tha': { eng: 'Thai', ger: 'Thailändisch', fre: 'thaï' },
      'language|tig': { eng: 'Tigre', ger: 'Tigre', fre: 'tigré' },
      'language|tir': { eng: 'Tigrinya', ger: 'Tigrinja', fre: 'tigrigna' },
      'language|tiv': { eng: 'Tiv', ger: 'Tiv', fre: 'tiv' },
      'language|tkl': { eng: 'Tokelau', ger: 'Tokelauanisch', fre: 'tokelau' },
      'language|tlh': { eng: 'Klingon', ger: 'Klingonisch', fre: 'klingon' },
      'language|tli': { eng: 'Tlingit', ger: 'Tlingit', fre: 'tlingit' },
      'language|tmh': { eng: 'Tamashek', ger: 'Tamaeq', fre: 'tamacheq' },
      'language|tog': { eng: 'Tonga (Nyasa)', ger: 'Tonga (Bantusprache, Sambia)', fre: 'tonga (Nyasa)' },
      'language|ton': { eng: 'Tonga (Tonga Islands)', ger: 'Tongaisch', fre: 'tongan (Îles Tonga)' },
      'language|tpi': { eng: 'Tok Pisin', ger: 'Neumelanesisch', fre: 'tok pisin' },
      'language|tsi': { eng: 'Tsimshian', ger: 'Tsimshian', fre: 'tsimshian' },
      'language|tsn': { eng: 'Tswana', ger: 'Tswana', fre: 'tswana' },
      'language|tso': { eng: 'Tsonga', ger: 'Tsonga', fre: 'tsonga' },
      'language|tuk': { eng: 'Turkmen', ger: 'Turkmenisch', fre: 'turkmène' },
      'language|tum': { eng: 'Tumbuka', ger: 'Tumbuka', fre: 'tumbuka' },
      'language|tup': { eng: 'Tupi', ger: 'Tupi', fre: 'tupi' },
      'language|tur': { eng: 'Turkish', ger: 'Türkisch', fre: 'turc' },
      'language|tut': { eng: 'Altaic', ger: 'Altaische Sprachen (Andere)', fre: 'altaïques' },
      'language|tvl': { eng: 'Tuvalu', ger: 'Elliceanisch', fre: 'tuvalu' },
      'language|twi': { eng: 'Twi', ger: 'Twi', fre: 'twi' },
      'language|tyv': { eng: 'Tuvinian', ger: 'Tuwinisch', fre: 'touva' },
      'language|udm': { eng: 'Udmurt', ger: 'Udmurtisch', fre: 'oudmourte' },
      'language|uga': { eng: 'Ugaritic', ger: 'Ugaritisch', fre: 'ougaritique' },
      'language|uig': { eng: 'Uighur', ger: 'Uigurisch', fre: 'ouïgour' },
      'language|ukr': { eng: 'Ukrainian', ger: 'Ukrainisch', fre: 'ukrainien' },
      'language|umb': { eng: 'Umbundu', ger: 'Mbundu', fre: 'umbundu' },
      'language|und': { eng: 'Undetermined', ger: 'Nicht zu entscheiden', fre: 'indéterminée' },
      'language|urd': { eng: 'Urdu', ger: 'Urdu', fre: 'ourdou' },
      'language|uzb': { eng: 'Uzbek', ger: 'Usbekisch', fre: 'ouszbek' },
      'language|vai': { eng: 'Vai', ger: 'Vai', fre: 'vaï' },
      'language|ven': { eng: 'Venda', ger: 'Venda', fre: 'venda' },
      'language|vie': { eng: 'Vietnamese', ger: 'Vietnamesisch', fre: 'vietnamien' },
      'language|vol': { eng: 'Volapük', ger: 'Volapük', fre: 'volapük' },
      'language|vot': { eng: 'Votic', ger: 'Wotisch', fre: 'vote' },
      'language|wak': { eng: 'Wakashan', ger: 'Wakash', fre: 'wakashanes' },
      'language|wal': { eng: 'Wolaitta', ger: 'Walamo', fre: 'wolaitta' },
      'language|war': { eng: 'Waray', ger: 'Waray', fre: 'waray' },
      'language|was': { eng: 'Washo', ger: 'Washo', fre: 'washo' },
      'language|wen': { eng: 'Sorbian', ger: 'Sorbisch (Andere)', fre: 'sorabes' },
      'language|wln': { eng: 'Walloon', ger: 'Wallonisch', fre: 'wallon' },
      'language|wol': { eng: 'Wolof', ger: 'Wolof', fre: 'wolof' },
      'language|xal': { eng: 'Oirat', ger: 'Kalmückisch', fre: 'oïrat' },
      'language|xho': { eng: 'Xhosa', ger: 'Xhosa', fre: 'xhosa' },
      'language|yao': { eng: 'Yao', ger: 'Yao-Sprache (Bantusprache)', fre: 'yao' },
      'language|yap': { eng: 'Yapese', ger: 'Yapesisch', fre: 'yapois' },
      'language|yid': { eng: 'Yiddish', ger: 'Jiddisch', fre: 'yiddish' },
      'language|yor': { eng: 'Yoruba', ger: 'Yoruba', fre: 'yoruba' },
      'language|ypk': { eng: 'Yupik', ger: 'Ypik', fre: 'yupik' },
      'language|zap': { eng: 'Zapotec', ger: 'Zapotekisch', fre: 'zapotèque' },
      'language|zbl': { eng: 'Bliss', ger: 'Bliss-Symbol', fre: 'Bliss' },
      'language|zen': { eng: 'Zenaga', ger: 'Zenaga', fre: 'zenaga' },
      'language|zgh': { eng: 'Standard Moroccan Tamazight', ger: '', fre: 'amazighe standard marocain' },
      'language|zha': { eng: 'Zhuang', ger: 'Zhuang', fre: 'zhuang' },
      'language|znd': { eng: 'Zande', ger: 'Zande', fre: 'zandé' },
      'language|zul': { eng: 'Zulu', ger: 'Zulu', fre: 'zoulou' },
      'language|zun': { eng: 'Zuni', ger: 'Zuñi', fre: 'zuni' },
      'language|zxx': { eng: 'Not applicable', ger: 'Kein linguistischer Inhalt', fre: 'non applicable' },
      'language|zza': { eng: 'Zaza', ger: 'Zazaki', fre: 'zaza' }
    };

    this.locale_to_iso639_2_map = {};
    'aa:aar ab:abk ae:ave af:afr ak:aka am:amh an:arg ar:ara as:asm av:ava ay:aym az:aze ba:bak be:bel bg:bul bh:bih bi:bis bm:bam bn:ben bo:tib br:bre bs:bos ca:cat ce:che ch:cha co:cos cr:cre cs:cze cu:chu cv:chv cy:wel da:dan de:ger dv:div dz:dzo ee:ewe el:gre en:eng eo:epo es:spa et:est eu:baq fa:per ff:ful fi:fin fj:fij fo:fao fr:fre fy:fry ga:gle gd:gla gl:glg gn:grn gu:guj gv:glv ha:hau he:heb hi:hin ho:hmo hr:hrv ht:hat hu:hun hy:arm hz:her ia:ina id:ind ie:ile ig:ibo ii:iii ik:ipk io:ido is:ice it:ita iu:iku ja:jpn jv:jav ka:geo kg:kon ki:kik kj:kua kk:kaz kl:kal km:khm kn:kan ko:kor kr:kau ks:kas ku:kur kv:kom kw:cor ky:kir la:lat lb:ltz lg:lug li:lim ln:lin lo:lao lt:lit lu:lub lv:lav mg:mlg mh:mah mi:mao mk:mac ml:mal mn:mon mr:mar ms:may mt:mlt my:bur na:nau nb:nob nd:nde ne:nep ng:ndo nl:dut nn:nno no:nor nr:nbl nv:nav ny:nya oc:oci oj:oji om:orm or:ori os:oss pa:pan pi:pli pl:pol ps:pus pt:por qu:que rm:roh rn:run ro:rum ru:rus rw:kin sa:san sc:srd sd:snd se:sme sg:sag si:sin sk:slo sl:slv sm:smo sn:sna so:som sq:alb sr:srp ss:ssw st:sot su:sun sv:swe sw:swa ta:tam te:tel tg:tgk th:tha ti:tir tk:tuk tl:tgl tn:tsn to:ton tr:tur ts:tso tt:tat tw:twi ty:tah ug:uig uk:ukr ur:urd uz:uzb ve:ven vi:vie vo:vol wa:wln wo:wol xh:xho yi:yid yo:yor za:zha zh:chi zu:zul'
      .split(' ').forEach(e => { const kv = e.split(':'); this.locale_to_iso639_2_map[kv[0]] = kv[1]; });


    this.hook = function (what, obj) {};

    this.translate = function (phrase) {
      if (typeof this.translateWordList[phrase] === 'undefined') return phrase;
      if (typeof this.translateWordList[phrase][this.ui_lang] === 'undefined') {
        if (typeof this.translateWordList[phrase].eng !== 'undefined') return this.translateWordList[phrase].eng;
        return phrase;
      }
      return this.translateWordList[phrase][this.ui_lang];
    };

    this.prepareDocOpt = { hl: true };
    this.prepareDoc = doc => {
      if (this.prepareDocOpt.hl && this.checkData('_hl_meta.highlighting', false)) {
        for (const [fieldname, metaArr] of Object.entries(doc)) {
          if (!fieldname.match(/^(meta_name_\w+_txt|meta_title_txt|meta_shelflocator_txt|meta_date_txt)$/)) continue;
          if (!Array.isArray(metaArr)) continue;
          const hlDoc = this.data._hl_meta.highlighting[doc.id];
          if (typeof hlDoc === 'undefined') continue;
          if (typeof hlDoc[fieldname] === 'undefined') continue;
          for (let i = 0; i < metaArr.length; i++) {
            hlDoc[fieldname].forEach(line => {
              const lineWithEm = $('<textarea />').html(line).text(); // macht aus »Chitic&#44;&#32;<em>Oleg</em>« → »Chitic, <em>Oleg</em>«
              const lineWoEm = lineWithEm.replace(/<em>/g, '').replace(/<\/em>/g, '');
              if (metaArr[i] !== lineWoEm) return;
              metaArr[i] = lineWithEm.replace(/<em>/g, '\uE000').replace(/<\/em>/g, '\uE001');
            });
          }
        } // for (const [fieldname, metaArr] of Object.entries(doc))
      }

      if (doc.domain_s === 'digi.ub.uni-heidelberg.de') {
        if (typeof doc.url_introimage_s !== 'undefined') {
          doc.url_introimage_s = doc.url_introimage_s.replace('/introimage/', '/introimage_klein/');
        }
        if (typeof doc._url_introimage_s !== 'undefined') {
          doc._url_introimage_s = doc._url_introimage_s.replace('/introimage/', '/introimage_klein/');
        }
      } // if (doc.domain_s === 'digi.ub.uni-heidelberg.de')

      if (typeof doc.meta_link_txt !== 'undefined' && Array.isArray(doc.meta_link_txt)) {
        doc.meta_link_txt.forEach(l => {
          const markMatch = l.match(/^@\}\$~([^ ]*)/); // ohne /g
          if (!markMatch) return;
          const txt = l.substring(markMatch[0].length + 1);
          if (txt.match(/heidicon/i)) {
            const p = getQueryParameters(markMatch[1]);
            if (p.L[0] === this.ui_lang || typeof doc._link_heidicon_txt === 'undefined') {
              doc._link_heidicon_url = p.U[0];
              doc._link_heidicon_txt = txt;
            }
          }
        });
      }

      if (typeof doc.meta_title_txt !== 'undefined' && Array.isArray(doc.meta_title_txt)) {
        // Falls es mehrere Titel gibt und einer davon bevorzugt ist (...P=1...), alle anderen entfernen
        let anyPreferred = false;
        doc.meta_title_txt.forEach(l => {
          if (l.indexOf('~P=1') < 0 && l.indexOf('&P=1') < 0) return;
          anyPreferred = true;
        });
        if (anyPreferred) {
          const newTitle = [];
          doc.meta_title_txt.forEach(l => {
            if (l.indexOf('~P=1') < 0 && l.indexOf('&P=1') < 0) return;
            const space = l.indexOf(' ');
            if (space >= 0) l = l.substring(space + 1);
            newTitle.push(l);
          });
          doc.meta_title_txt = newTitle;
        } // if (anyPreferred)
      } // if (typeof doc.meta_title_txt !== 'undefined' && Array.isArray(doc.meta_title_txt))
    }; // this.prepareDoc

    this.makeSimplifiedBiblio = doc => {
      doc._names_html = this.getNames(doc);
      doc._shelflocator_html = this.getShelflocator(doc);
      doc._physicallocation_html = this.getPhysicalLocation(doc);
      doc._title_ppptd_html = this.getTitle(doc, 'prependPeriodicalPartnumberToDate');
      doc._title_html = this.getTitle(doc);
      doc._names_title_html = [doc._names_html, doc._title_html].filter(function (o) { return o.length; }).join(': ');
      doc._place_html = this.getPlace(doc);
      doc._date_ppptd_html = this.getDate(doc, 'prependPeriodicalPartnumberToDate');
      doc._date_html = this.getDate(doc);
      doc._place_date_ppptd_html = this.getPlaceDate(doc, 'prependPeriodicalPartnumberToDate');
      doc._place_date_html = this.getPlaceDate(doc);
      // ab 2021-10-29: place_date ist schon ohne Klammern
      doc._place_date_wo_parentheses_html = doc._place_date_html;
      doc._biblio_html = this.getBiblio(doc);
      const b = document.createElement("dummy_biblio");
      b.innerHTML=doc._biblio_html;
      doc._biblio_txt = b.textContent;
      
      doc._id_classname = idEncode(doc.id);
    };
  } // constructor()

  locale_to_iso639_2 (l) {
    const f = l.split(/[_-]/);
    if (f[0].length === 3) return f[0];
    if (f[0].length !== 2) {
      console.log(`graphq.js, line 932: locale_to_iso639_2: '${l}'.length !== 2`);
      return 'eng';
    }
    return this.locale_to_iso639_2_map[f[0]];
  }

  getNames (doc) {
    let aut = [];
    let edt = [];
    let rest = [];
    for (const [key, values] of Object.entries(doc)) {
      if (key === 'meta_name_aut_txt') aut = aut.concat(values); // concat()! KEIN push()
      else if (key === 'meta_name_edt_txt') edt = edt.concat(values); // TODO edtk?
      else if (key.match(/^meta_name_\w+_txt$/)) rest = rest.concat(values);
    }
    let all = [];
    all = all.concat(aut);
    all = all.concat(edt);
    all = all.concat(rest);
    if (!all.length) return '';
    all = unique(all.filter(nonempty)); // UBHD Bug Erfassung Metadaten, daher unique
    return '<span class="meta_name">' + all.map(x => escapeHtml(x)).join('; ') + '</span>';
  }

  getShelflocator (doc) {
    if (!Array.isArray(doc.meta_shelflocator_txt)) return;
    let handschrift = 0;
    if (doc.parent_ids.includes('/digi.ub.uni-heidelberg.de/collection/handschriften')) handschrift++;
    if (Array.isArray(doc.meta_subject_genre_txt) && doc.meta_subject_genre_txt.join(';').match(/Handschrift/i)) handschrift++;
    if (!handschrift) return;
    const sl = doc.meta_shelflocator_txt.join('; ');
    return '<span class="meta_shelflocator">' + escapeHtml(sl) + '</span>';
  }

  translateType (s) {
    // Logik: wenn nicht definiert → nichts ausgeben
    if (typeof this.metsTypes[s] === 'undefined') return '';
    if (this.metsTypes[s].no_title) return '';
    return `<span class="meta_type">${this.metsTypes[s][this.ui_lang]}</span>`;
  }

  getPhysicalLocation (doc) {
    if (!Array.isArray(doc.meta_physicallocation_txt)) return '';
    if (Array.isArray(doc.meta_title_txt)) return '';
    if (!Array.isArray(doc.meta_shelflocator_txt)) return '';
    return '<span class="meta_physicallocation">' + escapeHtml(doc.meta_physicallocation_txt) + '</span>';
  }

  getTitle (doc, prependPeriodicalPartnumberToDate) {
    if (!Array.isArray(doc.meta_title_txt) && doc._parent_type_s === 'periodical') return this.translateType(doc.type_s);
    let t = [];
    if (doc._parent_type_s !== 'periodical' && prependPeriodicalPartnumberToDate) t = t.concat(doc.meta_part_number_txt);
    t = t.concat(this.translateIdField(doc.id, 'meta_title_txt'));
    t = t.filter(nonempty);
    // if (!t.length) return this.translateType(doc.type_s); // TODO - macht doch eh schon getBiblio() ??
    if (!t.length) return '';
    return '<span class="meta_title">' + escapeHtml(t.join(': ')) + '</span>';
  }

  getPlace (doc) {
    if (!Array.isArray(doc.meta_place_txt)) return '';
    return doc.meta_place_txt.join(', ');
  }

  formatDate (s) {
    //              YYYY-   MM        -        DD
    if (!s.match(/^-?\d+-(0?\d|1[0-2])-(0?\d|1\d|2\d|3[0-1])/)) return s; // 2005-1 würde zu 1.1.2005, wir wollen aber wahrscheinlich eher 1.2005...
    let d;
    try {
      const ss = s.replace(/Z$/, ''); // TODO Datum zukünftig in UTC in solr speichern, nicht localtime.
      d = new Date(ss);
    } catch (err) {
      return s;
    }
    return d.toLocaleDateString(this.locale);
  }

  getDate (doc, prependPeriodicalPartnumberToDate) {
    if (!Array.isArray(doc.meta_date_txt)) return ''; // TODO UBHD Bug in mysql book.log beispiel am1890 »Ilion«: part=>{host=>{number}} auch in allen Kapiteln!
    let prefix = '';
    if (doc._parent_type_s === 'periodical' && Array.isArray(doc.meta_part_number_txt) && prependPeriodicalPartnumberToDate) prefix = doc.meta_part_number_txt.join('/') + '.';
    return prefix + doc.meta_date_txt.map(v => this.formatDate(v)).join(', ');
  }

  getPlaceDate (doc, prependPeriodicalPartnumberToDate) {
    let t = [];
    t.push(this.getPlace(doc));
    t.push(this.getDate(doc, prependPeriodicalPartnumberToDate));
    t = t.filter(nonempty);
    if (!t.length) return '';
    return '<span class="meta_place_date">' + escapeHtml(t.join(', ')) + '</span>';
  }

  getBiblio (doc) {
    const all = [];
    all.push(doc._names_html);
    all.push(doc._title_ppptd_html);

    let biblio = [all.filter(nonempty).join(': ')];
    biblio.push(doc._place_date_ppptd_html);
    biblio = biblio.filter(nonempty).join(' ');
    const sl = doc._shelflocator_html;
    const pl = doc._physicallocation_html;
    biblio = [[pl, sl].filter(nonempty).join(' '), biblio].filter(nonempty).join(' ');
    if (biblio.length === 0 && 'firstpage_i' in doc) {
      biblio = '<span class="meta_page">' + this.translate('page') + ' ' + escapeHtml(doc.firstpage_i) + '</span>';
    }
    if (biblio.length === 0) biblio = this.translateType(doc.type_s); // ist bereits html
    if (biblio.length === 0) biblio = '<span class="meta_empty">\u2014 \u2205 \u2014</span>'; // TODO warum wird &emdash; zu &amp;emdash; ??
    return `<a href='${doc._url_s}' target='_new' title="${doc._biblio_txt}">${biblio}</a>`;
  }

  getHierarchyDocs (doc) { // for doc.type_s=meta! only
    const hier = [doc]; // initial doc must be present for while(... hier[0].parent_ids ...) below
    let anyParentFound = true;
    const deDuplicate = {}; // für den Fall, dass parent_ids "id" enthält
    while (anyParentFound && typeof hier[0].parent_ids !== 'undefined') {
      anyParentFound = false;
      hier[0].parent_ids.forEach(pid => {
        if (deDuplicate[pid]) return;
        deDuplicate[pid] = 1;
        if (typeof this.data._hlDocById[pid] === 'undefined') return;
        if (this.data._hlDocById[pid].class_s !== 'meta') return; // TODO was ist mit 'annotation' ?
        hier.unshift(this.data._hlDocById[pid]);
        anyParentFound = true;
      });
    }

    let url;
    let introimage;
    /* project annotations not in hierarchy any more -> code can be removed

    let hierHasAnno = false;
    let hierHasNonAnno = false;
    let maxNonAnnoPos = -1;
    let hierPos = -1; */
    hier.forEach(h => {
      /* hierPos++;
      if (typeof h.type_s === 'string') {
        if (h.type_s === 'annotation') hierHasAnno = true;
        else {
          hierHasNonAnno = true;
          maxNonAnnoPos = hierPos;
        }
      } */

      if (typeof h.url_s === 'string' && h.url_s.length > 0) {
        url = h.url_s;
      }
      if (typeof url === 'undefined') {
        url = 'http://this.url.is.undefined/';
        console.log('graphq.js, line 1080: url undefined! ' + h.id);
      }
      if (url.match(/^https?:\/\/anno\.ub\.uni-heidelberg\.de\/anno\/anno\//)) {
        // #TODO kann weg - wenn Urls wie https://anno.ub.uni-heidelberg.de/anno/anno/a230dada-8978-3659-99f0-612cbaef41b5.27
        // funktionieren (-> Nils)
        url = url.replace(/\.\d+$/, '');
      }
      h._url_s = url;

      if (typeof h.url_introimage_s === 'string' && h.url_introimage_s.length > 0) {
        introimage = h.url_introimage_s;
      }
      h._url_introimage_s = introimage;
    });

    /* if (hierHasAnno && hierHasNonAnno) {
      // skip higher level annotations (higher level = lower index position)
      const filteredHier = [];
      for (let i = 0; i < hier.length; i++) {
        if (typeof hier[i].type_s === 'string' && hier[i].type_s === 'annotation' && i <= maxNonAnnoPos) continue;
        filteredHier.push(hier[i]);
      }
      return filteredHier;
    } */

    return hier;
  }

  typeHook (type_s) {
    // if (type_s === 'monograph') return '<i class="fa fa-book"></i>';
    // if (type_s === 'multivolume_work') return '<i class="fa fa-book"></i>';
    return '';
  }

  getHierarchyBiblio (doc, start) { // start wg. Zwischenüberschriften: erst unterhalb der Ebene
    const docDomain = doc.domain_s.replace(/\./g, '_');
    let html = `<ul class="hierarchy domain_${docDomain}">`;
    let first = true;
    let startFound = typeof start === 'undefined' ? true : false;
    if(!Array.isArray(doc._hierarchy)) {
      console.log(`graphq.js, getHierarchyBiblio: doc.id=${doc.id} without _hierarchy`);
      return '';
    }
    doc._hierarchy.forEach(h => {
      if(startFound) {
        html += `<li class="type_${h.type_s}">` + (first ? this.typeHook(h.type_s) : '') + h._biblio_html + '</li>';
        first = false;
      }
      if(h.id === start) startFound=true;
    });
    return html + '</ul>';
  }

  decodeHtmlEncMarkStr (html) { // html is without @}$~
    // https://stackoverflow.com/questions/5796718/html-entity-decode
    const str = $('<textarea />').html(html).text();
    return getQueryParameters(str);
  }

  // hId is for finding the url for project annotations
  // perhaps for other highlighting cases, too? #TODO
  getHighlightingPerField (doc, fieldname, array, deDup, hId) { // doc hat alle Felder außer text_*
    let html = `<ul class="highlighting highlighting_${fieldname}">`;
    // Beispiel Highlighting: http://serv7:8982/solr/Suchindex/select?q=text_ocr_ft:schliemann&fq=id%3Adigi.ub.uni-heidelberg.de/diglit/cesnola1894bd2$0004$0001&hl=true&hl.method=unified&hl.fl=text*&hl.bs.type=SEPARATOR&hl.bs.separator=%0A
    array.forEach(txt => {
      // Bei Solr kann </em> auch mal am Zeilenanfang stehen (vor @}$~ )... daher:
      // split() mit capture »()« für Zeilenumbruch \n und @}$~
      const snippet = txt.split(/((?:&#10;|&#[xX]0[aA];)|(?:(?:@|&#64;|&#[xX]40;)(?:\}|&#125;|&#[xX]7[dD];)(?:\$|&#36;|&#[xX]24;)(?:~|&#126;|&#[xX]7[eE])))/);
      for (let i = 0; i < snippet.length; i++) {
        const startsWithMark = i > 0 && snippet[i - 1].match(/^(?:@|&#64;|&#[xX]40;)(?:\}|&#125;|&#[xX]7[dD];)(?:\$|&#36;|&#[xX]24;)(?:~|&#126;|&#[xX]7[eE])$/);
        let l = snippet[i];

        const emMatch = l.match(/(<\/?em>)/g); // mit /g, 0 = erster Treffer
        if (typeof emMatch === 'undefined' || !Array.isArray(emMatch)) continue;
        let mark = [];
        if (startsWithMark) {
          const htmlEncMarkMatch = l.match(/^(.*?)(&#32;|&[xX]20;| )/); // .*? = non-greedy; ohne /g, 0 = gesamter Inhalt
          if (typeof htmlEncMarkMatch !== 'undefined' && Array.isArray(htmlEncMarkMatch)) {
            mark = this.decodeHtmlEncMarkStr(htmlEncMarkMatch[1]);
            l = l.substr(htmlEncMarkMatch[1].length + htmlEncMarkMatch[2].length);
          }
        }
        if (deDup[l]) continue;
        deDup[l] = 1;
        if (emMatch[0] === '</em>') l = '<em>' + l;
        if (emMatch[emMatch.length - 1] === '<em>') l = l + '</em>';
        if (l === '<em></em>') continue;
        l = l.replace(/<em>/g, '<span class="hit_highlight">').replace(/<\/em>/g, '</span>');
        let url = doc._url_s; // siehe getHierarchyDocs

        let alt = 'Trefferzeile im Original anzeigen';
        if (fieldname.match(/html/)) alt = alt.replace(/Original/, 'Original (HTML)');
        if (fieldname.match(/pdf/)) alt = alt.replace(/Original/, 'Original (PDF)');

        let snippetDoc = doc;
        if (typeof mark.i5 !== 'undefined') {
          if (typeof this.data._hlDocById[mark.i5] !== 'undefined') snippetDoc = this.data._hlDocById[mark.i5];
        }
        let urlDocType = doc.type_s;
        if (snippetDoc.url_s !== 'undefined') {
          url = snippetDoc.url_s;
          urlDocType = snippetDoc.type_s;
        }
        if (typeof mark.p !== 'undefined' && fieldname.match(/^text_pdf/)) {
          const search = encodeURIComponent(this.data.responseHeader.params._hl_q_pdf);
          url = snippetDoc.url_pdf_ss[mark.u - 1] + '?inline=true#page=' + mark.p + `&amp;search="${search}"`; // ?inline=true gehört nur zu journals, heiup, archiv; wird aber hoffentlich nicht stören.
        }
        if (fieldname.match(/^text_html/)) {
          url = snippetDoc.url_html_ss[mark.u - 1];
        }
        if (typeof mark.p !== 'undefined' && snippetDoc.domain_s === 'digi.ub.uni-heidelberg.de' && urlDocType !== 'annotation') {
          if (!fieldname.match(/^text_pdf/)) {
            url = url.replace(/\/[0-9]+$/, '') + '/' + mark.p.toString().padStart(4, '0') + '?ft_query=' + encodeURIComponent(this.data.responseHeader.params._hl_q_digi) + '&amp;navmode=fulltextsearch';
          }
        }
        if (snippetDoc.domain_s === 'heieditions.ub.uni-heidelberg.de') {
          const search = encodeURIComponent(this.data.responseHeader.params._hl_q_pdf);
          url = url.replace(/#.*/, '') + `?search=${search}#${mark.a}`;
        }
        // TODO VORSICHT: url sollte »&amp;« statt »&« enthalten, da in HTML
        if (url.match(/&(?!amp;)/)) { console.log(`graphq.js, line 1184: WARNING: HTML will contain URL »${url}« which has »&« without »amp;«`); }
        // TODO "workaround" beseitigen:
        url = url.replace(/&(?!(?:[a-zA-Z][a-zA-Z0-9]*|#[xX][0-9a-fA-F]+|#[0-9]+);)/g, '&amp;').replace(/'/, '&#39;');
        html += `<li><a ${typeof this.hl_a_target === 'string' ? "target='"+this.hl_a_target+"'" : ""} href='${url}' title='${alt}'>${l}</a></li>`;
      }
    });
    if (html === `<ul class="highlighting highlighting_${fieldname}">`) return '';
    return html + '</ul>';
  }

  appendChildren (id, list) {
    if (typeof this.data._childIds === 'undefined') return;
    if (typeof this.data._childIds[id] === 'undefined') return;
    this.data._childIds[id].forEach(cid => {
      if (id === cid) return; // verhindert nur direkte Zirkelbezüge, jedoch nicht über mehrere Ebenen hinweg
      if (!list.includes(cid)) list.push(cid);
      this.appendChildren(cid, list);
    });
  }

  prependParents (id, list) {
    if (typeof this.data._hlDocById[id] === 'undefined') return;
    if (typeof this.data._hlDocById[id].parent_ids === 'undefined') return;
    this.data._hlDocById[id].parent_ids.forEach(pid => {
      if (id === pid) return; // verhindert nur direkte Zirkelbezüge, jedoch nicht über mehrere Ebenen hinweg
      this.prependParents(pid, list);
      if (!list.includes(pid)) list.push(pid);
    });
  }

  getHighlighting (doc) {
    // _hl_meta ist immer da, _hl_meta.highlighting ggf. nicht
    if (!this.checkData('_hl_text.highlighting') && !this.checkData('_hl_meta.highlighting')) return '';
    let html = '';
    '_hl_meta,_hl_text'.split(',').forEach(mt => {
      if (typeof this.data[mt] === 'undefined') return;
      if (typeof this.data[mt].highlighting === 'undefined') return;
      let hIds = [];
      if (mt === '_hl_meta') this.prependParents(doc.id, hIds);
      hIds.push(doc.id); // "selber" nicht vergessen
      if (mt === '_hl_text') this.appendChildren(doc.id, hIds);
      // TODO Reihenfolge norm, class, meta?
      // momentan implizit mit .sort():
      //   /digi = class, d-nb = norm, digi.ub = meta
      hIds = hIds.sort();

      const hierAnnoIds = {};
      doc._hierarchy.forEach(d => {
        if (typeof d.type_s === 'string' && d.type_s !== 'annotation') return;
        hierAnnoIds[d.id] = 1;
      });

      const deDup = [];
      hIds.forEach(hId => {
        let hIdHtml = '';
        if (typeof this.data[mt].highlighting[hId] === 'undefined') {
          if (typeof this.debug_xx1 === 'undefined') {
            console.log(`graphq.js, line 1238, mt="${mt}", hId="${hId}"`);
            console.log(this.data[mt]);
            console.log('weitere Faelle unterdrueckt');
            this.debug_xx1 = 1;
          }
          return;
        }
        for (const [fieldname, array] of Object.entries(this.data[mt].highlighting[hId])) {
          if (!array.length) continue;
          let annoAndInHier = false;
          if (this.data._hlDocById[hId].type_s === 'annotation') {
            if (hId in hierAnnoIds) annoAndInHier = true;
          } else {
            annoAndInHier = true;
          }
          // TAG meta_title_txt u. meta_name_txt als Volltext betrachten (mt===_hl_meta kann sonst weg.)
          if (mt === '_hl_meta' &&
            this.data._hlDocById[hId].class_s.match(/^(meta|norm)$/) &&
            annoAndInHier && // if annotation && in hierarchy (=biblio output)
            fieldname.match(/^meta_(name|title|place|physicallocation|shelflocator|link|date)_/) // TODO wieso link?
          ) continue;
          if (mt === '_hl_text' && // in _hl_text sind auch meta_name und meta_title!!!
            this.data._hlDocById[hId].class_s === 'meta' &&
            annoAndInHier && // if annotation && in hierarchy (=biblio output)
            fieldname.match(/^meta_(name|title)_/)
          ) continue;
          hIdHtml += this.getHighlightingPerField(doc, fieldname, array, deDup, hId);
        } // for (const [fieldname, array] of Object.entries(this.data[mt].highlighting[hId]))
        if(hIdHtml.length) { 
          html+=this.getHierarchyBiblio(this.data._hlDocById[hId], doc.id); // aber nur unterhalb doc.id
          html+=hIdHtml;
	}
      }); // hIds.forEach(hid =>
    }); // '_hl_meta,_hl_text'.split(',').forEach(mt =>
    return html;
  }

  checkData (str, checkArray) {
    let tmp = this.data;
    const s = str.split('.');
    for (let i = 0; i < s.length; i++) {
      const k = s[i];
      tmp = tmp[k];
      if (typeof tmp !== 'object') {
        // console.log(`not an object: data.${str}, at .${k}`)
        return false;
      }
    }
    if (checkArray && !Array.isArray(tmp)) {
      // console.log(`not an array: data.${str}`)
      return false;
    }
    return true;
  }

  getParentType (doc) { // returns type of first class_s:meta doc
    if (!Array.isArray(doc.parent_ids)) return '';
    const a = doc.parent_ids;
    for (let i = 0; i < a.length; i++) {
      const parentId = a[i];
      const parentDoc = this.data._hlDocById[parentId];
      if (typeof parentDoc === 'undefined') continue;
      if (parentDoc.class_s !== 'meta') continue;
      return parentDoc.type_s;
    }
  }

  makeFullResponseDocs () {
    let arr = [];
    if(this.checkData('response.docs', true)) arr.push(this.data.response.docs);
    if(this.checkData('_hl_text.response.docs', true)) arr.push(this.data._hl_text.response.docs);
    arr.forEach(docs => {
    for (let i = 0; i < docs.length; i++) {
      if (! (docs[i].id in this.data._hlDocById)) { // prevent fail and log
        console.log(`graphq.js, line 1310: makeFullResponseDocs(): ${docs[i].id} not in _hlDocById`);
        // Notbestückung:
        docs[i]._hierarchy = [ docs[i] ];
        docs[i].domain_s = docs[i].id.split('/')[0];
        docs[i]._parent_type_s = '(_parent_type_s undefined)';
        continue;
      }
      docs[i] = this.data._hlDocById[docs[i].id];
      docs[i]._hierarchy = this.getHierarchyDocs(docs[i]);
      docs[i]._parent_type_s = this.getParentType(docs[i]);
      // if(docs[i].id.match(/antiquitaeten_zeitung1897.0001/)) console.log(docs[i]);
    }
    }); // arr.forEach(docs =>
  }

  makeHlDocById () {
    this.data._hlDocById = {}; // neu aufbauen bei jedem Aufruf
    /* die Reihenfolge (erst _hl_text, dann alle anderen wie _hl_meta)
    ist — seit 7. Sept. 2022 — nicht mehr WICHTIG. Die _hl_meta.response.docs WAREN zu bevorzugen,
    weil nur in diesen alle Felder (meta_*, ...) für die Biblio-Anzeige sind.
    Siehe graphq.cgi bei _hl_text */
    '_hl_text,_facet_classification_meta,_hl_meta'.split(',').forEach(tm => {
      if (typeof this.data[tm] === 'undefined') return;
      this.data[tm].response.docs.forEach(doc => {
        this.data._hlDocById[doc.id] = doc;
        if ('id_md5_s' in doc) this.data._hlDocById[doc.id_md5_s] = doc;
      });
    });
  }

  // OPTIONAL(?): in this.data.response.docs als _child_ids einfügen
  makeChildIds () { // _childIds ist unsortiert
    this.data._childIds = {};
    '_hl_text,_hl_meta'.split(/,/).forEach(tm => {
      if (typeof this.data[tm] === 'undefined') return;
      this.data[tm].response.docs.forEach(d => {
        if (typeof d.parent_ids === 'undefined') return;
        d.parent_ids.forEach(pid => {
          if (typeof this.data._childIds[pid] === 'undefined') this.data._childIds[pid] = [];
          if (this.data._childIds[pid].includes(d.id)) return;
          this.data._childIds[pid].push(d.id);
        });
      });
    });
  }

  makeMetsTypes () {
    if (typeof this.metsTypes !== 'undefined') return;
    this.metsTypes = [];
    this.metsTypesList.forEach(x => {
      this.metsTypes[x.type] = x;
    });
  }

  prepareBiblio (treeq) {
    this.makeMetsTypes();
    // next line: treeq result already is ._hlDocById. …
    if (!treeq) this.makeHlDocById(); // Alle doc-typen. Legt _hlDocById{} an
    if (this.checkData('_hl_meta.response.docs', true)) {
      this.data._hl_meta.response.docs.forEach(doc => {
        if (doc.class_s !== 'meta' && doc.class_s !== 'annotation') return;
        this.prepareDoc(doc);
      });
    }
    this.makeFullResponseDocs(); // this.data.response.docs[] enthält nun alle Felder bis auf te* (nicht nur "id"); zusätzlich _hierarchy[]
    // makeFullResponseDocs() ruft getHierarchiyDocs() auf, das auch _url_s anlegt — Voraussetzung für makeSimplifiedBiblio()
    if (this.checkData('_hl_meta.response.docs', true)) {
      this.data._hl_meta.response.docs.forEach(doc => {
        if (doc.class_s !== 'meta' && doc.class_s !== 'annotation') return;
        this.makeSimplifiedBiblio(doc);
      });
    }
    /* else */ if (this.checkData('_hlDocById')) {
      for (const [id, doc] of Object.entries(this.data._hlDocById)) {
        if (doc.class_s !== 'meta' && doc.class_s !== 'annotation') continue;
        this.makeSimplifiedBiblio(doc);
      }
    }

    if (this.checkData('_facet_counts')) this.data.facet_counts = this.data._facet_counts.facet_counts;

    if (this.checkData('_facet_counts.responseHeader')) console.log(`graphq.js, line 1376: facet_counts: ${this.data._facet_counts.responseHeader.QTime} ms`);
    if (this.checkData('_facet_classification_meta.responseHeader')) console.log(`graphq.js, line 1377: facet_classification_meta: ${this.data._facet_classification_meta.responseHeader.QTime} ms`);
    if (this.checkData('responseHeader')) { // case data from treeq.cgi
      console.log(`graphq.js, line 1379: main: ${this.data.responseHeader.QTime} ms`);
    }
    if (this.checkData('_hl_meta.responseHeader')) console.log(`graphq.js, line 1380: hl+meta: ${this.data._hl_meta.responseHeader.QTime} ms`);
    if (this.checkData('_hl_text.responseHeader')) console.log(`graphq.js, line 1381: hl_text: ${this.data._hl_text.responseHeader.QTime} ms`);
  }

  prepareHighlighting () {
    this.makeChildIds(); // fürs Highlighting: legt _childIds{} an
    // _allParentIds{} wird nicht benötigt -> _hlDocById
  }

  decodeMarkAndText (l) {
    const markMatch = l.match(/^@\}\$~([^ ]*)/); // ohne /g
    if (!markMatch) return [{}, l];
    return [getQueryParameters(markMatch[1]), l.substring(4 + markMatch[1].length + 1)];
  }

  languagePrio (p) { // p like getQuery[P]arameter
    let prio = 50;
    if (typeof p === 'undefined') return prio;
    if (typeof p.L === 'undefined') return prio;
    if (p.L[0] === '') prio = 40; // TODO configurable
    if (p.L[0] === 'eng') prio = 30; // TODO configurable
    if (p.L[0] === 'ger') prio = 20; // TODO configurable
    if (p.L[0] === this.ui_lang) prio = 1;
    if (typeof p.P === 'undefined') return prio;
    if (p.L[0] === this.ui_lang && p.P[0] === 1) prio = 0;
    return prio;
  }

  translateIdField (id, fieldname) { // for class_s docs, only (other could have multiple different subjects/titles/...)
    // TODO OPTIONAL: group by i=... ([i]ndex = 0,1,2... | think array)
    if (typeof fieldname === 'undefined') return undefined;
    const doc = this.data._hlDocById[id];
    if (typeof doc === 'undefined') return undefined;
    // TODO following line can be skipped when group by i=... is implemented
    // if (doc.class_s !== 'classification' && doc.class_s !== 'collection') { console.log(`translate(): id: ${id}: class_s !== 'classification' && !== 'collection'`); }
    let field = doc[fieldname];
    if (typeof field === 'undefined') return undefined;
    field = field.sort((e1, e2) => { // smaller value => higher priority
      const dt1 = this.decodeMarkAndText(e1);
      const dt2 = this.decodeMarkAndText(e2);
      const p1 = this.languagePrio(dt1[0]);
      const p2 = this.languagePrio(dt2[0]);
      return p1 - p2;
    });
    const f = this.decodeMarkAndText(field[0]);
    return f[1]; // 1 = text
  }

  translateIdMultiField (id, fieldnames) {
    for (let i = 0; i < fieldnames.length; i++) {
      const t = this.translateIdField(id, fieldnames[i]);
      if (typeof t !== 'undefined') return t;
    }
    console.log(`translateIdMultiField('${id}', `, fieldnames, '): no translation found');
    return id;
  }

  facetSelect (include, entries, fieldname) {
    this.form.find('select[name="start"]').val(0);
    const termList = [];
    const displayList = [];
    entries.find('input:checked').each((i, v) => { termList.push(v.value); displayList.push(v.dataset.display); });
    if (!termList.length) return;
    const fn = fieldname === 'parent_ids' ? 'dos_of' : fieldname;

    /*  q.op=AND
        Fall "include": X ∧      ( A ∨ B )  ∧ Y

        Fall "exclude": X ∧ (  ¬( A ∨  B )) ∧ Y
                        X ∧ (    ¬A ∧ ¬B  ) ∧ Y
                        X ∧ (*:* ¬A ∧ ¬B  ) ∧ Y                     */

    const pre = include ? '' : '*:* ';
    const fop = include ? '' : '-';
    const joi = include ? ' OR ' : ' ';
    this.filterByFacet.push({
      expr: '/* facet */' + pre +
        termList.map(t => fop + fn + ':' + t).join(joi), // terms sind schon quoteSolr()
      fieldname: fieldname,
      display: (include ? '' : this.translate('NOT') + ' (') + displayList.join(` ${this.translate('OR')} `) + (include ? '' : ')')
    });
    this.formQuery();
  }

  getResult () {
    if (!this.checkData('response.docs', true)) {
      console.log(this.data);
      return;
    }
    this.prepareBiblio();
    if (typeof this.template !== 'undefined') {
      this.result.html(this.template(this.data));
      return;
    }
    this.prepareHighlighting();

    const facetsDiv = this.result_facet;
    if (this.filterByFacet.length) {
      $('<b>Filter:</b><br>').appendTo(facetsDiv);
    }
    if (this.filterByFacet.length) {
      const appliedUl = $('<ul class="facet_applied">').appendTo(facetsDiv);
      for (let i = 0; i < this.filterByFacet.length; i++) {
        const fbf = this.filterByFacet[i];
        const li = $('<li><i class="fa fa-check-circle"></i>' + this.translate('ff|' + fbf.fieldname) + ': ' + fbf.display + '</li>').appendTo(appliedUl);
        li.click(e => {
          const tmp = [];
          for (let k = 0; k < this.filterByFacet.length; k++) {
            if (i === k) continue;
            tmp.push(this.filterByFacet[k]);
          }
          this.filterByFacet = tmp;
          this.formQuery();
        });
      }
    } // if (this.filterByFacet.length)
    if (typeof this.data.facet_counts !== 'undefined') {
      $('<div class="facets-title">' + this.translate('filter') + '</div>').appendTo(facetsDiv);
      let fieldnames = [];
      this.facetParameterStr.split(/&/).forEach(e => {
        if (!e.length) return;
        const kv = e.split(/=/, 2);
        if (!kv[0].match(/^facet\.(field|range)/)) return;
        fieldnames.push(kv[1]);
      });
      if (this.facetSortAlphabetical) {
        fieldnames = fieldnames.sort((a, b) => {
          const at = this.translate('ff|' + a);
          const bt = this.translate('ff|' + b);
          return this.collator.compare(at, bt);
        });
      }
      fieldnames.forEach(fieldname => {
        'facet_fields,facet_ranges'.split(/,/).forEach(fiOrRa => {
          if (typeof this.data.facet_counts[fiOrRa] === 'undefined') return;
          if (typeof this.data.facet_counts[fiOrRa][fieldname] === 'undefined') return;
          let valCountPairs = this.data.facet_counts[fiOrRa][fieldname];
          if (!Array.isArray(valCountPairs)) valCountPairs = valCountPairs.counts; // _dtrs

          if (!valCountPairs.length) return;
          const div = $(`<div class="facet facet_field_${fieldname}">`).appendTo(facetsDiv);
          const icon = $('<i class="fa fa-plus-circle"></i>').appendTo(div);
          const titleDiv = $('<div class="facet_title">' + this.translate('ff|' + fieldname) + '</div>');
          titleDiv.appendTo(div);
          this.hook('facet div|' + fieldname, div);
          const entries = $('<div class="facet_entries facet_more_entry">').appendTo(div);
          icon.click(e => { icon.toggleClass('fa-plus-circle').toggleClass('fa-minus-circle'); entries.toggleClass('facet_more_entry'); });
          titleDiv.click(e => { icon.toggleClass('fa-plus-circle').toggleClass('fa-minus-circle'); entries.toggleClass('facet_more_entry'); });
          for (let i = 0; i < valCountPairs.length; i += 2) {
            // if (!valCountPairs[i + 1]) continue; // TODO kommt dieser Fall überhaupt vor?
            let tr = $('<div class="facet_entry">').appendTo(entries);
            let dispHtml = escapeHtml(valCountPairs[i]);
            let value = quoteSolr(valCountPairs[i]);
            if (fieldname === 'type_s' && typeof this.metsTypes[valCountPairs[i]] !== 'undefined' && typeof this.metsTypes[valCountPairs[i]][this.ui_lang] !== 'undefined') {
              dispHtml = escapeHtml(this.metsTypes[valCountPairs[i]][this.ui_lang]);
            } else if (fieldname === 'parent_ids') {
              let parentIds = [];
              this.prependParents(valCountPairs[i], parentIds);
              parentIds.push(valCountPairs[i]);
              if (parentIds.length && parentIds[0].endsWith('/classification')) parentIds.shift();
              // next line: every geonames entry begins with »Earth / ... / ...«, »Geonames / Earth / ...« not necessarry
              if (parentIds.length && parentIds[0].endsWith('/geonames')) parentIds.shift();
              for (let i = 0; i < parentIds.length; i++) {
                parentIds[i] = this.translateIdMultiField(parentIds[i], ['meta_subject_txt', 'label_ss']);
              }
              // filter() wg. Sonderfall /digi.ub.uni-heidelberg.de und /digi.ub.uni-heidelberg.de/collection:
              parentIds = parentIds.filter(x => x.trim().length);
              let k = 1;
              parentIds = parentIds.map(x => `<span class="facet_field_parent_ids_word_level${k++}">${escapeHtml(x)} / </span>`);
              dispHtml = parentIds.join(''); // filter() wg. Sonderfall /digi.ub.uni-heidelberg.de und /digi.ub.uni-heidelberg.de/collection
              dispHtml = dispHtml.replace(/ \/ <\/span>$/, '</span>');
            } else if (fieldname === 'meta_language_ss') {
              dispHtml = escapeHtml(this.translate(`language|${valCountPairs[i]}`));
            } else if (fieldname === 'domain_s') {
              if (valCountPairs[i] === 'gnd') continue;
              dispHtml = escapeHtml(this.translate(`domain|${valCountPairs[i]}`));
            } else if (fieldname.match(/_dtrs$/)) {
              const display = valCountPairs[i].replace(/([+-]?\d)-.*/, '$1');
              dispHtml = escapeHtml(display);
              value = '[' + display + '-01-01T00:00:00Z TO ' + display + '-12-31T23:59:59Z]';
            }
            let dispHtmlAbbr = dispHtml;
            if (fieldname === 'meta_periodical_title_s' && valCountPairs[i].length > 80) {
              dispHtmlAbbr = escapeHtml(valCountPairs[i].substr(0, 80)) + '&hellip;';
            }

            if (i === 10 * 2 && valCountPairs.length >= 11 * 2) { // TODO facet count configurable
              const moreStr = $(`<div class="facet_word"><i>${this.translate('more...')}</i></div>`).appendTo(tr);
              moreStr.click(e => { moreStr.parent().remove(); entries.children().removeClass('facet_more_entry'); });
              tr = $('<div class="facet_entry">').appendTo(entries);
            }
            if (i >= 10 * 2 && valCountPairs.length >= 11 * 2) {
              tr.addClass('facet_more_entry');
            }

            const disp=dispHtml.replace(/<[^>]*>/g, ''); // dispHtml in HTML-Attribute schreiben ist keine soo gute Idee
            $(`<input class="facet_checkbox" type="checkbox" name="value" value="${escapeHtml(value)}" data-display="${disp}" aria-label="${disp}">`).appendTo(tr);
            $(`<div class="facet_word">${dispHtmlAbbr}</div>`).appendTo(tr);
            $(`<div class="facet_count">${valCountPairs[i + 1]}</div>`).appendTo(tr);
          }
          const fab = $('<div class="facet_buttons"></div>').appendTo(entries);
          $('<button>' + this.translate('select') + '</button>').appendTo(fab)
            .click(e => this.facetSelect(true, entries, fieldname));
          $('<button>' + this.translate('exclude') + '</button>').appendTo(fab)
            .click(e => this.facetSelect(false, entries, fieldname));
        });
      });
    } // if (typeof this.data.facet_counts !== 'undefined')

    // process response.docs
    const firstHit = $('<a name="first_hit"></a>').appendTo(this.result);
    $(`<div class="numFound">${this.data.response.numFound} ` + this.translate('hits') + '</div>').appendTo(this.result);
    const ul = $('<ul class="hits">').appendTo(this.result);
    let rowNum = 1;
    this.data.response.docs.forEach(doc => {
      const hb = this.getHierarchyBiblio(doc);
      // In CSS, identifiers (including element names, classes, and IDs in selectors) can contain only the characters [a-zA-Z0-9] and ISO 10646 characters U+00A0 and higher, plus the hyphen (-) and the underscore (_); they cannot start with a digit, two hyphens, or a hyphen followed by a digit.
      const idClass = idEncode(doc.id);
      const li = $(`<li class="hit ${idClass}">`).appendTo(ul);
      if (typeof doc._url_introimage_s === 'string') {
        $(`<img src='${doc._url_introimage_s}' alt="${this.translate('Cover of')} &quot;${escapeHtml(doc._hierarchy[0]._biblio_txt)}&quot;">`).appendTo(li); // TODO: introimage is not necessarily from _hierarchy[0]
      } else {
        const img = $('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="Platzhalter ohne Inhalt">').appendTo(li);
        $.ajax({
          url: 'https://digi.ub.uni-heidelberg.de/Suchindex/cgi-bin/suitable-introimage.cgi?id=' + encodeURIComponent(doc.id),
          success: (data) => {
            if (typeof data === 'undefined') return;
            if (data.response.numFound === 0) return;
            img.attr('src', data.response.docs[0].url_introimage_s);
            img.attr('alt', `${this.translate('Cover of')} "${escapeHtml(doc._hierarchy[0]._biblio_txt)}"`);
          }
        });
      }
      $(hb).appendTo(li);
      $(this.getHighlighting(doc)).appendTo(li);
      if (rowNum % 10 === 0) {
        const gtfh = $('<li class="goto_first_hit">').appendTo(ul);
        gtfh.click(e => { $('html,body').animate({ scrollTop: firstHit.offset().top }); });
      }
      rowNum++;
    });
    return 'getResult(): umgestellt auf .appendTo(this.result)';
  } // getResult()

  getFilterByFacet () {
    let qstr = '';
    this.filterByFacet.forEach(fbf => {
      // qstr += `&q={!tag=${e[0]}}` + encodeURIComponent(e[0] + ':' + quoteSolr(e[1]))

      /*
 / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / si
/ since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / sin
 since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / sinc
since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since
ince 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since

      // Caution! fq= is not the same query as q= for facet filtering
      // because fq is applied after q, and q result could deliver a resticted result set (because resultset_restriction)
      // not including the wanted docs by selected by facet.

 / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / si
/ since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / sin
 since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / sinc
since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since
ince 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since 2021-04-28: q≈fq / since
*/

      qstr += '&q=' + encodeURIComponent(fbf.expr); // aber in graphq.cgi: if($q[$i]=~s"^/\*\s*facet\s*\*/"") { $facet=1; }
    });
    return qstr;
  }

  query (cgi, queryString) {
    this.result.empty();
    if (typeof this.result_facet !== 'undefined') this.result_facet.empty();
    $.ajax({
      type: 'POST',
      url: cgi,
      data: queryString, // TODO: »+ '&rows=' + this.rows.toString(),« ???
      success: (data) => { /*
          data enthält:
          solr-Rückgabe -- docs nur mit id
          + _meta -- docs mit allen Feldern außer te* = text_*
          + _hl (Highlighting)
            -> docs nur id, parent_ids, class_s
            -> highlighting mit Feldern text_* und/oder meta_*
        */
        this.data = data;
        this.getResult();
      },
      error: (xhr, status, error) => {
        console.log('graphq.js, line 1670: ajax error; xhr=', xhr, ', status=', status, ', error=', error);
      }
    });
  }

  toggleButton (btn, state) { // state==true → disabled
    btn.prop('disabled', state);
    if (state) btn.addClass('button-disabled'); else btn.removeClass('button-disabled');
  }

  formQuery () { // (optionally full) form processing (with back/forward etc.)
    if (this.formRequestRunning) {
      console.log('graphq.js, line 1682: excess formQuery() call: ', new Date()); // TODO kann weg, nur wegen Problemen mit den Buttons (preventDefault, off('click'))
      return;
    }
    this.result.empty();
    if (typeof this.result_facet !== 'undefined') this.result_facet.empty();
    const graphq_cgi = this.form.attr('action');
    // f → for comparison with this.prevQuery, see below.
    const f = this.form.serialize().replace(/&start=\d+/, '');
    const rows = this.form.find('*[name="rows"]').val();
    if (rows > 0) this.rows = rows;

    const start = this.form.find('select[name="start"]');
    const back = this.form.find('button[name="back"]');
    const forward = this.form.find('button[name="forward"]');
    const begin = this.form.find('button[name="begin"]');
    const end = this.form.find('button[name="end"]');

    let start2, back2, forward2, begin2, end2;
    if (typeof this.buttons2 !== 'undefined') {
      start2 = this.buttons2.find('select[name="start"]');
      back2 = this.buttons2.find('button[name="back"]');
      forward2 = this.buttons2.find('button[name="forward"]');
      begin2 = this.buttons2.find('button[name="begin"]');
      end2 = this.buttons2.find('button[name="end"]');
    }

    if (f !== this.prevQuery) {
      [start, start2].filter(nonempty).forEach(x => x.val(0));
      this.filterByFacet = [];
    }
    this.prevQuery = f;
    this.formRequestRunning = true;
    this.result.html('<img src="https://digi.ub.uni-heidelberg.de/Suchindex/htdocs/spinner.gif">');
    $.ajax({
      type: 'POST',
      url: graphq_cgi,
      data: this.form.serialize() + this.getFilterByFacet() + this.facetParameterStr + '&rows=' + this.rows.toString() + this.extraParameters,
      success: (data) => {
        this.result.empty(); // spinner.gif wieder weg.
        if (typeof data === 'undefined') { console.log('graphq.js, line 1721: $.ajax(): data = ', data); return; }
        if (typeof data.response === 'undefined') { console.log('graphq.js, line 1722: $.ajax(): data.response = ', data.response, '\ngraphq_cgi = “<form action=…” = ', graphq_cgi, '\ndata = ', data); return; }
        this.data = data;

        let startVal;
        if (typeof start !== 'undefined') startVal = parseInt(start.val());
        if (typeof startVal === 'undefined' || Number.isNaN(startVal)) startVal = 0;

        this.data._pagination = {};
        const pagi = this.data._pagination;
        pagi.allPages = [];
        const calcPage = (val) => { return Math.round(val / this.rows) + 1; };
        for (let i = 0; i < this.data.response.numFound; i += this.rows) {
          pagi.allPages.push({
            start: i,
            page: calcPage(i),
            isBegin: i === 0,
            isMinus1: i === startVal - this.rows,
            isCurrent: i === startVal,
            isPlus1: i === startVal + this.rows,
            isEnd: i === Math.floor(this.data.response.numFound / this.rows) * this.rows
          });
        }
        pagi.begin = { start: 0, page: 1 };
        pagi.minus1 = { start: startVal - this.rows, page: calcPage(startVal - this.rows) };
        pagi.current = { start: startVal, page: calcPage(startVal) };
        pagi.plus1 = { start: startVal + this.rows, page: calcPage(startVal + this.rows) };
        pagi.end = { start: Math.floor(this.data.response.numFound / this.rows) * this.rows, page: calcPage(Math.floor(this.data.response.numFound / this.rows) * this.rows) };

        if (pagi.begin.start === pagi.current.start) pagi.begin = undefined;
        if (pagi.minus1.start < 0) pagi.minus1 = undefined;
        if (pagi.plus1.start > this.data.response.numFound) pagi.plus1 = undefined;
        if (pagi.end.start === pagi.current.start) pagi.end = undefined;

        this.data._groups = {};
        if (this.checkData('_facet_counts.facet_counts.facet_fields.meta_name_aut_firstchar_ss', true)) {
          const a = this.data._facet_counts.facet_counts.facet_fields.meta_name_aut_firstchar_ss;
          const b = [];
          for (let i = 0; i < a.length; i += 2) {
            b.push({ key: a[i], count: a[i + 1] });
          }
          this.data._groups.meta_name_aut_firstchar_ss = b;
        }

        if (typeof this.groupTemplate !== 'undefined') {
          this.groupTemplate.forEach(gt => {
            if (gt.div.html().length > 0 && gt.static) return;
            const p = gt.template(this.data);
            gt.div.html(p);
            gt.div.find('*[data-graphq-group-fq]').click(e => {
              $(this.form).find("*[name='start']").val(0);
              $(this.form).find('*[data-graphq-group-fq]').val(quoteSolr($(e.target).data('graphq-group-fq')));
              this.formQuery();
            });
          });

          if (typeof this.paginationTemplate === 'undefined') {
            this.getResult();
            return;
          }
        }

        if (typeof this.paginationTemplate !== 'undefined') {
          this.paginationTemplate.forEach(pt => {
            const p = pt.template(pagi);
            pt.div.html(p);
            pt.div.find('*[data-graphq-start]').click(e => {
              $(this.form)
                .find("*[name='start']")
                .val($(e.target).data('graphq-start')); // .value gibt "find is not a function" ???
              this.formQuery();
            });
          });
          this.getResult();
          return;
        }

        if (this.debug) { console.log(this.data); console.log(JSON.stringify(pagi)); }

        [start, start2].filter(nonempty).forEach(x => {
          this.toggleButton(x, this.data.response.numFound <= this.rows);
          x.empty();
          for (let i = 0; i <= this.data.response.numFound; i += this.rows) {
            const selected = i === startVal ? 'selected=\'selected\'' : '';
            $(`<option value='${i}' ${selected}>${i + 1} ..</option>`).appendTo(x);
          }
          x.one('change', e => {
            if (x === start && typeof start2 !== 'undefined') start2.val(start.val()); // damit der start2-Dropdown den gleichen Wert anzeigt (sieht man nur kurz, weil gleich wieder die Ergebnisliste befüllt wird)
            if (x === start2 && typeof start !== 'undefined') start.val(start2.val());
            e.preventDefault();
            this.formQuery();
          });
        });

        [back, back2].filter(nonempty).forEach(x => {
          this.toggleButton(x, startVal < this.rows);
          x.one('click', e => {
            e.preventDefault();
            startVal -= this.rows;
            [start, start2].filter(nonempty).forEach(y => y.val(startVal));
            this.formQuery();
          });
        });

        [forward, forward2].filter(nonempty).forEach(x => {
          this.toggleButton(x, startVal >= this.data.response.numFound - this.rows);
          x.one('click', e => {
            e.preventDefault();
            startVal += this.rows;
            [start, start2].filter(nonempty).forEach(y => y.val(startVal));
            this.formQuery();
          });
        });

        [begin, begin2].filter(nonempty).forEach(x => {
          this.toggleButton(x, startVal == 0); // »==« or »===« ?!
          x.one('click', e => {
            e.preventDefault();
            startVal = 0;
            [start, start2].filter(nonempty).forEach(y => y.val(startVal));
            this.formQuery();
          });
        });

        [end, end2].filter(nonempty).forEach(x => {
          this.toggleButton(x, startVal >= Math.floor(this.data.response.numFound / this.rows) * this.rows);
          x.one('click', e => {
            e.preventDefault();
            startVal = Math.floor(this.data.response.numFound / this.rows) * this.rows;
            [start, start2].filter(nonempty).forEach(y => y.val(startVal));
            this.formQuery();
          });
        });

        const sort = this.form.find('select[name="sort"]');
        sort.one('change', e => {
          e.preventDefault();
          this.formQuery();
        });
        const resRes = this.form.find('select[name="resultset_restriction"]');
        resRes.one('change', e => {
          e.preventDefault();
          this.formQuery();
        });

        this.getResult();
      }, // success
      error: (xhr, status, error) => {
        if (typeof xhr.responseJSON !== 'undefined') {
          this.result.html('<div class="error">' + escapeHtml(xhr.responseJSON.error.msg) + '</div>');
        }
        console.log('graphq.js, line 1871: ajax error; xhr=', xhr, ', status=', status, ', error=', error);
      }, // error
      complete: () => {
        this.formRequestRunning = false;
      } // complete
    }); // $.ajax()
  } // formQuery()

  // wenn die Behandlung von ui_lang nur in urlParameterToForm() stattfindet, muss urlP...() zuerst aufgerufen werden!
  setupForm (up) {
    if (typeof up === 'undefined') up = getUrlParameters();

    if (typeof up.ui_lang !== 'undefined') this.ui_lang = up.ui_lang[0];

    if (typeof this.force_ui_lang !== 'undefined') this.ui_lang = this.force_ui_lang;

    /* TODO locale, ui_lang: locale brauchen wir für Sortierung, z. B. von Facetten;
       Prio: 1. urlParameter 'locale', 2. <input>, 3. window.locale? 4. this.locale  }---> this.ui_lang */

    const rr = this.form.find('select[name="resultset_restriction"]');
    rr.empty();
    this.formOptions.resultset_restriction.forEach(w => {
      $(`<option value='${w}'>` + this.translate(`resultset_restriction|${w}`) + '</option>').appendTo(rr);
    });
    const so = this.form.find('select[name="sort"]');
    so.empty();
    if (typeof this.formOptions !== 'undefined') {
      this.formOptions.sort.forEach(w => {
        $(`<option value='${w}'>` + this.translate(`sort|${w}`) + '</option>').appendTo(so);
      });
    }

    const qfo = this.form.find('select[name="qf"]');
    console.log(`graphq.js, setupForm() ui_lang=${this.ui_lang}`);
    for (let i = 0; i < qfo.length; i++) {
      // TODO »qfo[i].empty is not a function« qfo[i].empty();
      this.formOptions.qfo.forEach(fn => {
        let selected = '';
        if (fn === this.formOptions.qfoOrder[i]) selected = 'selected';
        $(`<option value='${fn}' ${selected}>` + this.translate(`qf|${fn}`) + '</option>').appendTo(qfo[i]);
      });
    }

    // Übersetzungen:
    this.form.find('[data-text]').each((i, o) => {
      o = $(o);
      const tn = o.prop('tagName');
      const t = this.translate(o.attr('data-text'));
      if (tn === 'INPUT') {
        o.attr('value', t);
      } else {
        o.text(t); // SPAN, BUTTON
      }
    });

    const redirect = this.form.data('redirect');
    this.form.keydown(e => {
      if (e.keyCode !== 13) { return; }
      e.preventDefault();
      if (typeof redirect === 'undefined') { // wie darunter
        this.formQuery();
      } else {
        console.log('graphq.js, line 1932: this.ui_lang', this.ui_lang);
        window.open(redirect + '?' + this.form.serialize() + '&ui_lang=' + this.ui_lang, 'graphqRedirect');
      }
    });

    // https://stackoverflow.com/questions/1960240/jquery-ajax-submit-form
    this.form.submit(e => {
      e.preventDefault(); // avoid to execute the actual submit of the form.
      if (typeof redirect === 'undefined') {
        this.formQuery();
      } else {
        window.open(redirect + '?' + this.form.serialize() + '&ui_lang=' + this.ui_lang, 'graphqRedirect');
      }
    });
  }

  urlParameterToForm (up) {
    if (typeof up === 'undefined') up = getUrlParameters();

    // dublett zu setupForm, aber aus Rückwärtskompatibilität:
    if (typeof up.ui_lang !== 'undefined') this.ui_lang = up.ui_lang[0];

    if (typeof this.force_ui_lang !== 'undefined') this.ui_lang = this.force_ui_lang;

    let qfq = 0; // qf und q PAARweise
    if (typeof up.qf !== 'undefined') qfq = up.qf.length;
    if (typeof up.q !== 'undefined' && up.q.length > qfq) qfq = up.q.length;

    let insertPos = this.form.find('input[name="q"]'); // TODO nicht-hidden!
    if (typeof insertPos !== 'undefined') insertPos = insertPos[insertPos.length - 1];
    else insertPos = this.form.find('*')[0];

    for (let i = 0; i < qfq; i++) {
      // erst qf klären ...
      let up_qf = [];
      if (typeof up.qf !== 'undefined') up_qf = up.qf;
      let select = this.form.find('select[name="qf"]')[i];
      if (typeof select === 'undefined') {
        select = $('<select name="qf">').insertAfter(insertPos);
        insertPos = $(select);
      }
      const option = $(select).find(`option[value="${up_qf[i]}"]`);
      if (option.length < 1) {
        let label = this.translateWordList['qf|' + up_qf[i]];
        if (typeof label === 'undefined') label = typeof up_qf[i] === 'undefined' ? '' : up_qf[i];
        else label = label[this.ui_lang];
        $(`<option value="${up_qf[i]}">${label}</option>`).appendTo(select);
      }
      if (typeof up_qf[i] !== 'undefined') $(select).val(up_qf[i]);

      // dann q ...
      let up_q = [];
      if (typeof up.q !== 'undefined') up_q = up.q;
      let input = this.form.find('input[name="q"]')[i];
      if (typeof input === 'undefined') {
        input = $('<input name="q">').insertAfter(insertPos);
        insertPos = $(input);
      }
      if (typeof up_q[i] !== 'undefined') $(input).val(up_q[i]);
    }

    // fq ...
    if (typeof up.fq !== 'undefined') {
      for (let i = 0; i < up.fq.length; i++) {
        let input = this.form.find('input[name="fq"]')[i];
        if (typeof input === 'undefined') {
          input = $('<input name="fq" type="hidden">').appendTo(this.form);
        }
        $(input).val(up.fq[i]); // OOPS »input.value = ...« does not work with .serialize() ??? 2020-09-11
      }
    }

    if (typeof up.resultset_restriction !== 'undefined') this.form.find('select[name="resultset_restriction"]').val(up.resultset_restriction[0]);
    if (typeof up.sort !== 'undefined') {
      let select = this.form.find('select[name="sort"]')[0];
      if (typeof select === 'undefined') {
        select = $('<select name="sort">').appendTo(this.form);
      }
      const option = $(select).find(`option[value="${up.sort[0]}"]`);
      if (option.length < 1) {
        $(`<option value="${up.sort[0]}">${up.sort[0]}</option>`).appendTo(select);
      }
      $(select).val(up.sort[0]);
    }
    if (typeof up.start !== 'undefined') {
      const s = this.form.find('select[name="start"]');
      $(`<option value='${up.start}'>${up.start + 1}</option>`).appendTo(s); // es gibt noch keine <option> in html
      this.prevQuery = this.form.serialize().replace(/&start=\d+/, ''); // damit nicht wegen "changed" query gleich wieder auf 0 zurückgesetzt wird
    }
  }
}
